import i18n from "i18next";
import {initReactI18next} from "react-i18next";

i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        lng: "pl",
        fallbackLng: "pl",
        interpolation: {
            escapeValue: false,
        },
        resources: {
            pl: {
                translation: {
                    defaultErrorMessage: "Wystąpił błąd podczas {{messageSuffix}}.\nSpróbuj ponownie później.",
                    defaultNoDataLoadErrorMessage: "Wystąpił błąd podczas {{messageSuffix}}.\nSpróbuj odświeżyć listę przyciskiem obok.",
                    mappedErrorMessage: "Wystąpił błąd podczas {{cause}}",
                    mappedErrorMessageAlreadyExist: "{{object}} o {{property}} {{value}} już istnieje",
                    mappedErrorMessageIsEmpty: "pole {{propertyForEmpty}} nie może być puste",
                    mappedErrorMessageWharfOccupied: "nabrzeże w danym czasie jest zajęte",
                    mappedErrorMessageFerryTaken: "prom w danym czasie jest zajęty",
                    mappedErrorMessageVoyageNoAndTypeAlreadyExists: "operacja {{type}} dla podróży nr {{voyageNo}} już istnieje",
                    mappedErrorMessageDateInvalid: "{{earlierTimeField}} nie może być późniejszy niż {{laterTimeField}}",
                    mappedErrorMessageCannotUpdate: "na tę podróż został już zarejestrowany bilet lub zlecenie",
                    mappedErrorMessageRouteNotFound: "trasa została usunięta",
                    mappedErrorMessageInvalidOrderStatus: "operacja edycji jest niedozwolona",
                    mappedErrorMessageBookingNoRejected: "numer rezerwacji istnieje już w systemie",
                    mappedErrorMessageTimetableNotMatched: "nie można znaleźć akcji harmonogramu dla danego biletu lub zlecenia",
                    mappedErrorMessageVoyageNumberAlreadyAssigned: "nie można dopasować numeru podróży do akcji harmonogramu",
                    mappedErrorMessageVoyageNumberTaken: "numer podróży przypisany jest już do innej akcji harmonogramu",
                    mappedErrorMessageUnknownShipownerNumber: "nie znaleziono armatora o takim kodzie IMO",
                    mappedErrorMessageUnknownFerryNumber: "nie znaleziono promu",
                    mappedErrorMessageUnknownUnCode: "nieznany kod UN",
                    mappedErrorMessageUnknownOriginDestinationPort: "port jest nieznany",
                    mappedErrorMessageUnknownOriginDestinationCountry: "kraj jest nieznany",
                    mappedErrorMessageWagonAlreadyAssigned: "numer wagonu jest przypisany do zlecenia",
                    mappedErrorMessageCannotCancel: "istnieje zlecenie, które jest aktualnie przetwarzane",
                    mappedErrorMessageInvalidOrderState: "nie można obsłużyć przejazdu. Przejazd niedozwolony",
                    mappedErrorMessagePinRejected: "kod PIN został odrzucony",
                    mappedErrorMessageBarcodeNoRejected: "nie można przypisać numeru kodu kreskowego. Kod istnieje już w systemie",
                    mappedErrorMessagePriceListWithSameTypeAndDate: "cennik nr {{value}}: dana relacja i data zostały już użyte",
                    mappedErrorMessageLocationInUse: "nie można usunąć lokalizacji, która jest używana",
                    mappedErrorMessageInvalidLocationType: "nie można usunąć lokalizacji tego typu",
                    errorMessages: {
                        required: "Pole wymagane",
                        dateIsNumber: "Data powinna składać się z cyfr w formacie dd.mm.yyyy",
                        correctDate: "Niepoprawna data",
                        dateFromIsEarlierThanDateTo: "Data od nie może być późniejsza od daty do",
                        onlyNumber: "Pole przyjmuje tylko cyfry nieujemne",
                        correctTemperature: "Niepoprawna wartość temperatury",
                        correctTime: "Niepoprawna godzina",
                        actionNo: "Akcja nr {{value}}:",
                        atLeastOneFilled: "Przynajmniej jeden musi być wypełniony",
                        ferriesErrorSuffix: "pobierania promów",
                        shipownersErrorSuffix: "pobierania armatorów",
                        wharfsErrorSuffix: "pobierania nabrzeży",
                        portsErrorSuffix: "pobierania portów",
                        relationTypeErrorSuffix: "pobierania rodzajów biletów/zleceń",
                        companiesErrorSuffix: "pobierania firm",
                        packingErrorSuffix: "pobierania opakowań",
                        unCodesErrorSuffix: "pobierania kodów UN",
                        whrafsErrorSuffix: "pobierania nabrzeży",
                        routesErrorSuffix: "pobierania tras",
                        locationsErrorSuffix: "pobierania lokalizacji",
                        signCodesErrorSuffix: "pobierania znaków",
                        cargoTypesErrorSuffix: "pobierania rodzajów ładunku",
                        countriesErrorSuffix: "pobierania krajów",
                        statusesErrorSuffix: "pobierania statusów"
                    },
                    remove: "Usuń",
                    modify: "Edytuj",
                    preview: "Podgląd",
                    yes: "Tak",
                    no: "Nie",
                    reloadMessage: "Odśwież",
                    more: "Więcej",
                    menu: "Menu",
                    printToFile: "Drukuj do pliku",
                    assignWagonsNumberBtn: "Przypisz numer wagonu",
                    weekdays: {
                        monday: "Poniedziałek",
                        tuesday: "Wtorek",
                        wednesday: "Środa",
                        thursday: "Czwartek",
                        friday: "Piątek",
                        saturday: "Sobota",
                        sunday: "Niedziela"
                    },
                    months: {
                        january: "Styczeń",
                        february: "Luty",
                        march: "Marzec",
                        april: "Kwiecień",
                        may: "Maj",
                        june: "Czerwiec",
                        july: "Lipiec",
                        august: "Sierpień",
                        september: "Wrzesień",
                        october: "Październik",
                        november: "Listopad",
                        december: "Grudzień"
                    },
                    cancel: "Anuluj",
                    save: "Zapisz",
                    add: "Dodaj",
                    dateFormat: "DD.MM.yyyy",
                    dateFormatWithTime: "DD.MM.yyy HH:mm",
                    timeWithDateFormat: "HH:mm-DD.MM.yyy",
                    priceFormat: "0,00",
                    pageable: {
                        rowsPerPageLabel: "Wierszy na stronie",
                        labelDisplayedRows: "z",
                        arialLabelNext: "następnej",
                        arialLabelBack: "poprzedniej",
                        arialLabelFirst: "pierwszej",
                        arialLabelLast: "ostatniej",
                        arriaLabel: "Idź do {{type}} strony"
                    },
                    userMenu: {
                        logout: "Wyloguj się",
                        changePassword: "Zmiana hasła",
                        selectOwnVehicle: "Wybierz/Zmień pojazd"
                    },
                    directionType: {
                        ARRIVAL: "Przybycie",
                        DEPARTURE: "Wyjście"
                    },
                    cargoType: {
                        NORMATIVE_TRAILER: "Naczepa",
                        NORMATIVE_CONTAINER: "Kontener",
                        NORMATIVE_GENERAL_CARGO: "Ładunek inny niż naczepa i kontener",
                        DANGEROUS_TRAILER: "Naczepa z ładunkiem niebezpiecznym",
                        DANGEROUS_CONTAINER: "Kontener z ładunkiem niebezpiecznym",
                        DANGEROUS_GENERAL_CARGO: "Ładunek niebezpieczny inny niż naczepa i kontener",
                        OVERSIZE: "Ponadgabarytowy",
                        LORRY: "Ciągnik, ciągnik z naczepą lub ciężarówka",
                        OVERSIZE_LORRY: "Ciągnik, ciągnik z naczepą lub ciężarówka ponadgabarytowy",
                        DANGEROUS_LORRY: "Ciągnik, ciągnik z naczepą lub ciężarówka z ładunkiem niebezpiecznym",
                        OVERSIZE_TRAILER: "Naczepa ponadgabarytowa"
                    },
                    orderStatus: {
                        REGISTERED: "Rejestracja",
                        CANCELED: "Anulowane",
                        PARKING_ENTERED: "Parking wjazd",
                        PARKING_EXITED: "Parking wyjazd",
                        CONFIRMED_BY_MANIFEST: "Manifest",
                        CANCELED_BY_MANIFEST: "Anulowane przez manifest",
                        DEPO_ENTERED: "Depo wjazd",
                        DEPO_EXITED: "Depo wyjazd",
                        FERRY_ENTERED: "Prom wjazd",
                        FERRY_EXITED: "Prom wyjazd"
                    },
                    relationType: {
                        TICKET_EXPORT: "Bilet",
                        ROAD_DEPO_FERRY: "Pojazd-DEPO-Prom",
                        FERRY_DEPO_ROAD: "Prom-DEPO-Pojazd",
                        RAIL_DEPO_FERRY: "Kolej-DEPO-Prom",
                        FERRY_DEPO_RAIL: "Prom-DEPO-Kolej",
                        RAIL_FERRY: "Kolej-Prom",
                        FERRY_RAIL: "Prom-Kolej",
                        ROAD_DEPO_ROAD: "Pojazd-DEPO-Pojazd",
                        ROAD_DEPO_RAIL: "Pojazd-DEPO-Kolej",
                        RAIL_DEPO_ROAD: "Kolej-DEPO-Pojazd",
                        RAIL_DEPO_RAIL: "Kolej-DEPO-Kolej",
                        FERRY_DEPO: "Prom-DEPO",
                        RAIL_DEPO: "Kolej-DEPO",
                        ROAD_DEPO: "Pojazd-DEPO",
                        DEFAULT: "Wszystkie"
                    },
                    searchButton: "Szukaj",
                    paymentMethod: {
                        CASH: "gotówka",
                        BANK_TRANSFER: "przelew"
                    },
                    activeStatus: {
                        ACTIVE: "Aktywny",
                        INACTIVE: "Nieaktywny"
                    },
                    actionType: {
                        arrival: "import",
                        stop: "postój",
                        departure: "export"
                    },
                    locationDropdownLabel: "Wybierz lokalizację",
                    allowPopup: {
                        headerEntry: "Zezwól na wjazd",
                        headerExit: "Zezwól na wyjazd",
                        headerWithOrder: "Zezwól na przejazd",
                        contentEntry: "Czy na pewno chcesz pozwolić ",
                        contentEntryWithoutOrder: "wjechać na lokalizację: ",
                        contentEntryWithOrder: "na przejazd {{orderText}} ",
                        order: "zlecenia o numerze: ",
                        ticket: "biletu o numerze: ",
                        contentExit: "Czy na pewno chcesz pozwolić na wyjazd",
                        contentExitWithoutOrder: " z lokalizacji: ",
                        actionText: "Zezwól",
                        errors: {
                            allowEntryErrorSuffix: "zezwalania na wjazd na lokalizację: {{locationName}}",
                            allowEntryWithOrderErrorSuffix: "zezwalania na przejazd dla {{orderType}} o numerze: {{orderId}}",
                            allowExitErrorSuffix: "zezwalania na wyjazd z lokalizacji: {{locationName}}",
                            orderError: "zlecenia",
                            ticketError: "biletu"
                        }
                    },
                    notAllowPopup: {
                        headerEntry: "Nie zezwalaj na wjazd",
                        headerExit: "Nie zezwalaj na wyjazd",
                        headerWithOrder: "Nie zezwalaj na przejazd",
                        contentEntry: "Czy na pewno nie chcesz pozwolić ",
                        contentEntryWithoutOrder: " wjechać na lokalizację: ",
                        contentEntryWithOrder: "na przejazd {{orderText}} ",
                        order: "zlecenia o numerze: ",
                        ticket: "biletu o numerze: ",
                        contentExitWithoutOrder: "Czy na pewno nie chcesz pozwolić na wyjazd z lokalizacji: ",
                        actionText: "Nie zezwalaj",
                        errors: {
                            notAllowEntryErrorSuffix: "nie pozwalania na wjazd na lokalizację: {{locationName}}",
                            notAllowExitErrorSuffix: "nie pozwalania na wyjazd z lokalizacji: {{locationName}}",
                            notAllowEntryWithOrderErrorSuffix: "nie pozwalania na przejazd dla {{orderType}} o numerze: {{orderId}}",
                            orderError: "zlecenia",
                            ticketError: "biletu"
                        }
                    },
                    ownedVehiclePopup: {
                        header: "Wybierz pojazd",
                        actionText: "Wybierz",
                        otherBtn: "Bez pojazdu",
                        dataLoadingError: "pobierania pojazdów własnych",
                        vehicleActions: "wykonywania akcji ",
                        withVehicle: "przypisania pojazdu do użytkownika",
                        withoutVehicle: "pomijania wyboru pojazdu",
                        emptyMessage: "Nie ma żadnych pojazdów własnych do wyboru",
                        noSelectErrorMessage: "Wybierz pojazd z listy lub pomiń za pomocą przycisku `Bez pojazdu`"
                    },
                    dictionaries: {
                        title: "Słowniki",
                        retrievalErrorSuffix: "pobierania słownika",
                        itemRetrievalErrorSuffix: "pobierania danych",
                        removeAction: {
                            header: "Czy na pewno chcesz usunąć pozycję?",
                            secondHeader: "Usuń pozycję",
                            actionText: "Tak, usuń",
                            line1: "Czy na pewno chcesz usunąć pozycję z listy?",
                            line2: "Tej akcji nie można cofnąć!"
                        },
                        ferries: {
                            title: "Promy",
                            actions: {
                                addFerry: {
                                    button: "Dodaj prom +",
                                    header: "Dodaj prom"
                                },
                                modifyFerry: {
                                    header: "Edytuj prom"
                                }
                            },
                            headers: {
                                number: "Numer IMO promu",
                                name: "Nazwa promu",
                                flagStateName: "Kraj bandery",
                                shipownerName: "Armator"
                            },
                            errors: {
                                removeErrorSuffix: "usuwania promu",
                                addErrorSuffix: "dodawnia nowego promu",
                                modifyErrorSuffix: "edycji promu",
                                ferryNoLengthIsCorrect: "Numer IMO nie może być dłuższy niż {{number}} znaków"
                            },
                            httpErrors: {
                                object: "prom",
                                number: "numerze",
                                name: "nazwie",
                                numberForEmpty: "numer IMO",
                                nameForEmpty: "nazwa",
                                flagStateNameForEmpty: "kraj bandery",
                                shipownerForEmpty: "armator"
                            }
                        },
                        ports: {
                            title: "Porty",
                            actions: {
                                addPort: {
                                    button: "Dodaj port +",
                                    header: "Dodaj port"
                                },
                                modifyPort: {
                                    header: "Edytuj port"
                                }
                            },
                            headers: {
                                name: "Nazwa portu",
                                imoCode: "Kod IMO",
                                country: "Kraj"
                            },
                            errors: {
                                removeErrorSuffix: "usuwania portu",
                                addErrorSuffix: "dodawnia nowego portu",
                                modifyErrorSuffix: "edycji portu",
                                portImoCodeLengthIsCorrect: "Numer IMO nie może być dłuższy niż {{number}} znaki"
                            },
                            httpErrors: {
                                object: "port",
                                nameForEmpty: "nazwa portu",
                                imoCodeForEmpty: "kod IMO",
                                countryForEmpty: "kraj",
                                name: "nazwie portu",
                                imoCode: "kodzie IMO",
                                country: "nazwie kraju"
                            }
                        },
                        companies: {
                            title: "Firmy",
                            bankTransferLabel: "Rozliczenie za pomocą przelewu",
                            headers: {
                                name: "Nazwa firmy",
                                taxNo: "Kod NIP",
                                phoneNo: "Telefon",
                                street: "Adres",
                                city: "Miasto",
                                postalCode: "Kod pocztowy",
                                countryName: "Kraj"
                            },
                            actions: {
                                addCompany: {
                                    button: "Dodaj firmę +",
                                    header: "Dodaj firmę"
                                },
                                modifyCompany: {
                                    header: "Edytuj firmę"
                                },
                                addNextDetail: "Dodaj kolejny +",
                                removeDetail: {
                                    header: "Czy na pewno chcesz usunąć pozycję?",
                                    secondHeader: "Usuń pozycję",
                                    actionText: "Tak, usuń",
                                    line1: "Czy na pewno chcesz usunąć pozycję z listy?",
                                    line2: "Tej akcji nie można cofnąć!"
                                }
                            },
                            errors: {
                                addErrorSuffix: "dodawnia nowej firmy",
                                removeErrorSuffix: "usuwania firmy",
                                modifyErrorSuffix: "edycji firmy"
                            },
                            httpErrors: {
                                object: "firma",
                                taxNo: "kodzie NIP",
                                name: "nazwie",
                                nameForEmpty: "nazwa firmy",
                                taxNoForEmpty: "kod NIP",
                                phoneNoForEmpty: "telefon",
                                streetForEmpty: "adres",
                                cityForEmpty: "miasto",
                                postalCodeForEmpty: "kod pocztowy",
                                countryNameForEmpty: "kraj"
                            }
                        },
                        shipowners: {
                            title: "Armatorzy",
                            actions: {
                                addShipowner: {
                                    button: "Dodaj armatora +",
                                    header: "Dodaj armatora"
                                },
                                modifyShipowner: {
                                    header: "Edytuj armatora"
                                }
                            },
                            headers: {
                                name: "Nazwa armatora",
                                taxNo: "Kod NIP",
                                phoneNo: "Telefon",
                                street: "Adres",
                                city: "Miasto",
                                postalCode: "Kod pocztowy",
                                countryName: "Kraj",
                                imoCode: "Nr IMO"
                            },
                            errors: {
                                removeErrorSuffix: "usuwania armatora",
                                addErrorSuffix: "dodawania nowego armatora",
                                modifyErrorSuffix: "edycji armatora",
                                removeErrorWhenShipownerHasFerry: "armator posiada przypisany prom"
                            },
                            httpErrors: {
                                object: "armator",
                                name: "nazwie",
                                taxNo: "kodzie NIP",
                                nameForEmpty: "nazwa armatora",
                                taxNoForEmpty: "kod NIP",
                                phoneNoForEmpty: "telefon",
                                streetForEmpty: "adres",
                                cityForEmpty: "miasto",
                                postalCodeForEmpty: "kod pocztowy",
                                countryNameForEmpty: "kraj",
                                imoCodeForEmpty: "nr IMO"
                            }
                        },
                        unCodes: {
                            title: "Kody UN",
                            headers: {
                                status: "Status",
                                code: "Kod UN",
                                name: "Nazwa",
                                imdgClass: "Klasa IMDG"
                            },
                            actions: {
                                modifyUnCode: {
                                    header: "Edytuj kod UN"
                                },
                                addUnCode: {
                                    header: "Dodaj kod UN",
                                    button: "Dodaj kod UN +"
                                }
                            },
                            errors: {
                                removeErrorSuffix: "usuwania kodu UN",
                                addErrorSuffix: "dodawania kodu UN",
                                modifyErrorSuffix: "edycji kodu UN"
                            },
                            httpErrors: {
                                object: "kod UN",
                                code: "kodzie UN",
                                name: "nazwie",
                                statusForEmpty: "status",
                                codeForEmpty: "kod UN",
                                nameForEmpty: "nazwa",
                                imdgClassForEmpty: "klasa IMDG"
                            }
                        },
                        ownedVehicles: {
                            title: "Pojazy Własne",
                            actions: {
                                addOwnedVehicle: {
                                    button: "Dodaj pojazd +",
                                    header: "Dodaj pojazd"
                                },
                                modifyOwnedVehicle: {
                                    header: "Edytuj pojazd"
                                }
                            },
                            headers: {
                                name: "Nazwa",
                                licencePlate: "Numer rejestracyjny"
                            },
                            errors: {
                                removeErrorSuffix: "usuwania pojazdu własnego",
                                addErrorSuffix: "dodawania nowego pojazdu",
                                modifyErrorSuffix: "edycji pojazdu"
                            },
                            httpErrors: {
                                object: "pojazd",
                                nameForEmpty: "nazwa",
                                licencePlateForEmpty: "numer rejestracyjny",
                                name: "nazwa",
                                licencePlate: "numer rejestracyjny"
                            }
                        },
                        packing: {
                            title: "Opakowania",
                            actions: {
                                addPacking: {
                                    button: "Dodaj opakowanie +",
                                    header: "Dodaj opakowanie"
                                },
                                modifyPacking: {
                                    header: "Edytuj opakowanie"
                                }
                            },
                            headers: {
                                name: "Nazwa"
                            },
                            errors: {
                                removeErrorSuffix: "usuwania opakowania",
                                addErrorSuffix: "dodawnia nowego opakowania",
                                modifyErrorSuffix: "edycji opakowania"
                            },
                            httpErrors: {
                                object: "opakowanie",
                                nameForEmpty: "nazwa",
                                name: "nazwie"
                            }
                        }
                    },
                    timetable: {
                        title: "Harmonogram",
                        retrievalErrorSuffix: "pobierania harmonogramu",
                        wharf: "Nabrzeże",
                        periodDateLabel: "Prezentowany okres",
                        outsideTPS: "Poza TPŚ",
                        copyDataPopup: {
                            dataLabel: "Wybrany zakres dat",
                            header: "Kopiowanie harmonogramu",
                            actionText: "Zatwierdź",
                            errorMessage: "kopiowania wybranego tygodnia",
                            copyWeekErrorMessage: "Tydzień, który chcesz skopiować, nie może być wcześniejszy niż wybrany tydzień, na który ma być skopiowany.",
                            copyFromLabel: "Skopiuj z tego tygodnia: ",
                            toCopyLabel: "Do tego tygodnia: ",
                            errorSelectedWeekMessage: "wybierania tygodnia"
                        },
                        actions: {
                            addAction: {
                                button: "Dodaj nowy +",
                                header: "Dodaj nowy"
                            },
                            modifyAction: {
                                button: "Edycja",
                                header: "Edytuj"
                            },
                            detailsAction: {
                                button: "Szczegóły",
                                header: "Szczegóły: ",
                                cancelText: "Zamknij"
                            },
                            errors: {
                                errorMessage: "wczytywania danych"
                            },
                            download: {
                                button: "Pobierz harmonogram",
                                header: "Wybierz format pliku",
                                actionText: "Pobierz",
                                from: "Od",
                                to: "Do"
                            },
                            names: {
                                arrival: "Import (Przybycie-rozładunek)",
                                stop: "Postój",
                                departure: "Export (Wyjście-załadunek)"
                            },
                            copyDataBtn: "Kopiuj harmonogram",
                            addNextAction: "Dodaj kolejny +",
                            removeAction: {
                                header: "Czy na pewno chcesz usunąć {{value}}?",
                                position: "pozycję",
                                action: "akcję",
                                secondHeader: "Usuń {{value}}",
                                actionText: "Tak, usuń",
                                line1: "Czy na pewno chcesz usunąć {{value}}?",
                                line2: "Tej operacji nie można cofnąć!",
                                errorMessagePart1: "usuwania akcji",
                                errorMessagePart2: "do akcji został już zarejestrowany bilet lub zlecenie",
                            },
                            cancelAction: {
                                header: "Czy na pewno chcesz anulować akcję?",
                                secondHeader: "Anuluj akcję",
                                actionText: "Tak, anuluj",
                                line1: "Czy na pewno chcesz anulować akcję?",
                                line2: "Tej operacji nie można cofnąć!",
                                errorMessage: "anulowania akcji"
                            }
                        },
                        headers: {
                            ferry: "Prom",
                            actionType: "Operacja",
                            voyageNo: "Numer podróży",
                            wharf: "Numer nabrzeża",
                            notes: "Uwagi",
                            time: "Godzina",
                            plannedTime: "Planowany czas",
                            actualTime: "Faktyczny czas",
                            arrivalTime: "Planowany czas przybycia",
                            departureTime: "Planowany czas zwolnienia",
                            actualArrivalTime: "Faktyczny czas przybycia",
                            actualDepartureTime: "Faktyczny czas zwolnienia",
                            routeAndLoading: "Trasa i załadunek",
                            route: "Trasa",
                            startLoadingTime: "Czas rozpoczęcia załadunku",
                            endLoadingTime: "Czas zakończenia załadunku",
                            openParkingTime: "Czas otwarcia parkingu",
                            destinationPort: "Port docelowy",
                            filters: {
                                year: "Rok",
                                week: "Tydzień",
                                prevBtn: "Poprzedni tydzień",
                                nextBtn: "Następny tydzień"
                            }
                        },
                        errors: {
                            addErrorSuffix: "dodawania pozycji harmonogramu",
                            editErrorSuffix: "edycji pozycji harmonogramu",
                            downloadErrorSuffix: "pobierania harmonogramu",
                            voyageNoLength: "Numer podróży może mieć maksymalnie 15 znaków",

                        }
                    },
                    administration: {
                        title: "Administracja",
                        itemRetrievalErrorSuffix: "pobierania listy użytkowników",
                        headers: {
                            enabled: "Status",
                            username: "Login",
                            role: "Rola w zespole",
                            language: "Preferowany język"
                        },
                        status: {
                            enabled: "Aktywny",
                            disabled: "Zablokowany"
                        },
                        roles: {
                            administrator: "Administrator",
                            supervisor: "Supervisor",
                            observer: "Obserwator",
                            depo: "Depo",
                            helpdesk: "Helpdesk"
                        },
                        languages: {
                            pl: "Polski",
                            en: "Angielski"
                        },
                        actions: {
                            resetPassword: "Resetuj hasło",
                            disable: "Zablokuj",
                            enable: "Odblokuj",
                            addUser: "Nowy użytkownik +",
                            changePassword: "Zmień hasło"
                        },
                        errors: {
                            disableErrorSuffix: "blokowania użytkownika",
                            enableErrorSuffix: "odblokowania użytkownika",
                            resetPasswordErrorSuffix: "resetu hasła użytkownika",
                            changePasswordErrorSuffix: "ręcznej zmiany hasła użytkownika",
                            idNotFound: "użytkownik o id {{id}} nie istnieje",
                            invalidPassword: "Niepoprawne hasło. Nowe hasło musi składać się z minimum 8 znaków, zawierać przynajmniej jedną dużą literę, zawierać przynajmniej jedną mała literę, zawierać przynajmniej jedną cyfrę oraz różnić się od starego hasła."
                        },
                        disableAction: {
                            header: "Czy na pewno chcesz zablokować użytkownika?",
                            secondHeader: "Zablokuj użytkownika",
                            actionText: "Tak, zablokuj",
                            firstPart: "Czy na pewno chcesz zablokować użytkownika o nazwie ",
                            lastPart: "? Tą czynność można cofnąć."
                        },
                        enableAction: {
                            header: "Odblokować użytkownika?",
                            secondHeader: "Odblokuj użytkownika",
                            actionText: "Tak, odblokuj",
                            firstPart: "Chcesz odblokować użytkownika o nazwie ",
                            lastPart: "? Tą czynność można cofnąć."
                        },
                        resetPasswordAction: {
                            header: "Zresetować hasło użytkownika?",
                            secondHeader: "Reset hasła",
                            actionText: "Tak, zresetuj",
                            firstPart: "Chcesz zresetować hasło użytkownika o nazwie ",
                            lastPart: "? Tej czynności nie można cofnąć."
                        },
                        removeAction: {
                            header: "Czy chcesz usunąć użytkownika?",
                            secondHeader: "Usuń użytkownika",
                            actionText: "Tak, usuń",
                            firstPart: "Chcesz usunąć użytkownika o nazwie ",
                            lastPart: "? Tej czynności nie można cofnąć!",
                            errorMessage: " usuwania użytkownika"
                        },
                        changeUserPasswordAction: {
                            header: "Ręczna zmiana hasła dla użytkownika",
                            actionText: "Zmień hasło"
                        },
                        addUser: {
                            header: "Dodaj nowego użytkownika",
                            usernameAndPasswordSection: {
                                header: "Login i hasło",
                                username: "Login",
                                language: "Język",
                                password: "Hasło",
                                confirmPassword: "Potwierdź hasło "
                            },
                            permissionsSection: {
                                header: "Uprawnienia",
                                role: "Rola",
                                additionalRole: "Rola dodatkowa",
                                resetPasswordInfo: "(reset hasła)"
                            },
                            errors: {
                                addUserErrorSuffix: "dodawania nowego użytkownika",
                                incorrectPassword: "Hasło musi składać się z minimum 8 znaków, zawierać przynajmniej jedną dużą literę, zawierać przynajmniej jedną mała literę, zawierać przynajmniej jedną cyfrę.",
                                incorrectConfirmPassword: "Podane hasła muszą być takie same"
                            },
                            add: "Utwórz"
                        },
                        modifyUser: {
                            header: "Edytuj użytkownika",
                            resetPassword: "Reset hasła",
                            changePassword: "Zmień hasło",
                            errors: {
                                modifyUserErrorSuffix: "edycji użytkownika",
                                itemRetrievalErrorSuffix: "pobierania danych użytkownika"
                            }
                        }
                    },
                    user: {
                        changePassword: {
                            header: "Zmień hasło",
                            userAndPasswordHeader: "Login i hasło",
                            currentPassword: "Stare hasło",
                            newPassword: "Nowe hasło",
                            confirmPassword: "Powtórz hasło",
                            username: "Login",
                            errors: {
                                changePasswordErrorSuffix: "zmiany hasła",
                                incorrectPassword: "Hasło musi składać się z minimum 8 znaków, zawierać przynajmniej jedną dużą literę, zawierać przynajmniej jedną mała literę, zawierać przynajmniej jedną cyfrę.",
                                incorrectConfirmPassword: "Podane hasła muszą być takie same",
                                incorrectNewPassword: "Nowe hasło musi różnić się od starego",
                                invalidPassword: "wpisano niepoprawne stare hasło",
                                userNotFound: "nie znaleziono użytkownika {{username}}"
                            },
                            successFirstPart: "Udało się! ",
                            successSecondPart: "Hasło zostało zmienione."
                        }
                    },
                    transportation: {
                        notificationTile: "Komunikaty",
                        emptyNotificationMessage: "Brak komunikatów dla {{orderType}}",
                        tcrTile: "Stan naczepy (TCR)",
                        retrievalErrorSuffixForNotification: "pobierania komunikatów",
                        orderType: {
                            ticket: "biletu",
                            order: "zlecenia"
                        },
                        errorMessage: {
                            noLengthValidator: "Numer {{object}} nie może być dłuższy niż {{number}} znaków",
                            trailerRegNo: "naczepy",
                            lorryRegNo: "ciągnika",
                            containerNo: "kontenera",
                            wagonRegNo: "wagonu",
                            voyageNo: "podróży",
                            bookingNo: "rezerwacji",
                            cargoDesc: "Nazwa ładunku nie może być dłuższa ",
                            remarks: "Uwagi nie mogą być dłuższe ",
                            lengthValidator: "{{firstPart}} niż {{number}} znaków",
                            recipientLengthValidator: "Nazwa odbiorcy nie może być dłuższa niż {{number}} znaków"
                        },
                        filters: {
                            dateOfRegistrationFrom: "Data rejestracji: Od",
                            dateOfRegistrationTo: "Data rejestracji: Do",
                            arrivalDepartureTime: "Data wejścia/wyjścia",
                            relationType: "Rodzaj zlecenia",
                            ferry: "Prom",
                            orderStatus: "Status",
                            trailerNo: "Numer naczepy",
                            regNo: "Numer pojazdu"
                        },
                        ticket: {
                            title: "Ewidencja biletów",
                            retrievalErrorSuffix: "pobierania ewidencji biletów",
                            headers: {
                                status: "Status",
                                arrivalDepartureTime: "Czas odejścia",
                                createdAt: "Czas utworzenia",
                                relationType: "Relacja",
                                regNo: "Numer pojazdu",
                                shipownerName: "Armator",
                                ferry: "Prom",
                                gateNo: "Nr bramy",
                                info: "Info",
                                cargoType: "Rodzaj ładunku"
                            },
                            actions: {
                                modifyStatus: "Zmień status",
                                addNextDangerousGood: "Dodaj kolejny +",
                                scanTicket: "Skanuj bilet"
                            },
                            addTicket: {
                                header: "Dodaj nowy bilet",
                                button: "Zarejestruj bilet +",
                                saveButtonText: "Zarejestruj"
                            },
                            modifyTicket: {
                                header: "Edytuj bilet",
                                button: "Edytuj",
                                errors: {
                                    retrievalErrorSuffix: "pobierania biletu",
                                    modifyErrorSuffix: "edycji biletu"
                                }
                            },
                            details: {
                                general: {
                                    header: "Dane podstawowe",
                                    properties: {
                                        status: "Status",
                                        cargoType: "Rodzaj ładunku",
                                        currentRoute: "Bieżąca trasa",
                                        gateNo: "Numer bramy",
                                        createdAt: "Czas utworzenia",
                                        barcodeNo: "Kod kreskowy"
                                    }
                                },
                                transportation: {
                                    header: "Transport",
                                    properties: {
                                        trailerRegNo: "Numer naczepy",
                                        transportCompany: "Firma transportowa",
                                        lorryRegNo: "Nr ciągnika",
                                    }
                                },
                                voyage: {
                                    header: "Podróż",
                                    properties: {
                                        shipownerName: "Armator",
                                        voyageNo: "Numer podróży",
                                        arrivalDepartureTime: "Czas przybycia/wyjścia",
                                        ferryName: "Nazwa promu",
                                        originDestinationPort: "Port przeznaczenia/nadania",
                                        originDestinationCountry: "Kraj przeznaczenia/nadania",
                                        bookingNo: "Numer rezerwacji"
                                    }
                                },
                                cargo: {
                                    header: "Ładunek",
                                    properties: {
                                        cargoDesc: "Nazwa ładunku",
                                        weight: "Waga",
                                        height: "Wysokość",
                                        width: "Szerokość",
                                        length: "Długość",
                                        securingDeclaration: "Deklaracja sztauowania"
                                    }
                                },
                                dangerousGoods: {
                                    header: "Towary niebezpieczne",
                                    properties: {
                                        unCode: "Kod UN",
                                        packing: "Opakowanie",
                                        packingQuantity: "Liczba opakowań",
                                        packingGroup: "Kategoria opakowań",
                                        weight: "Waga"
                                    },
                                    thereMustBeAtLeastOne: "Przy tym rodzaju ładunku musi być wybrany przynajmniej jeden towar niebiezpieczny."
                                }
                            },
                            preview: {
                                header: "Bilet nr: {{number}}",
                                actions: {
                                    goBack: "Wróć do listy biletów",
                                    details: "Szczegóły biletu",
                                    alerts: "Komunikaty"
                                }
                            },
                            errors: {
                                addErrorSuffix: "rejestracji nowego biletu",
                                modifyErrorSuffix: "modyfikacji biletu",
                                correctDateWithTime: "Niepoprawna data z czasem",
                                detailsRetrievalErrorSuffix: "pobierania szczegółów biletu"
                            },
                            httpErrors: {
                                object: "bilet",
                                status: "statusie",
                                cargoType: "rodzaju ładunku",
                                gateNo: "numerze bramy",
                                currentRoute: "bieżącej trasie",
                                trailerRegNo: "numerze naczepy",
                                transportCompany: "firmie transportowej",
                                lorryRegNo: "numerze ciągnika",
                                shipownerName: "armatorze",
                                voyageNo: "numerze podróży",
                                arrivalDepartureTime: "czasie przybycia/wyjścia",
                                ferryName: "nazwie promu",
                                originDestinationPort: "porcie przeznaczenia",
                                originDestinationCountry: "kraju przeznaczenia",
                                cargoDesc: "nazwie ładunku",
                                weight: "wadze ładunku",
                                length: "długości",
                                width: "szerokości",
                                securingDeclaration: "deklaracji sztauowania",
                                unCode: "kodzie UN",
                                packing: "opakowaniu",
                                packingQuantity: "liczbie opakowań",
                                packingGroup: "kategorii opakowań",
                                dangerousGoodsWeight: "wadze niebezpiecznego towaru",
                                cargoTypeEmpty: "rodzaj ładunku",
                                gateNoEmpty: "numer bramy",
                                currentRouteEmpty: "bieżąca trasa",
                                trailerRegNoEmpty: "numer naczepy",
                                shipownerNameEmpty: "armator",
                                voyageNoEmpty: "numer podróży",
                                arrivalDepartureTimeEmpty: "czas przybycia/wyjścia",
                                ferryNameEmpty: "nazwa promu",
                                originDestinationPortEmpty: "port przeznaczenia",
                                originDestinationCountryEmpty: "kraj przeznaczenia",
                                weightEmpty: "waga ładunku",
                                lengthEmpty: "długość",
                                widthEmpty: "szerokość",
                                unCodeEmpty: "kod UN"
                            },
                            scanBarcodePopup: {
                                header: "Skaner biletów",
                                content: "Zeskanuj kod kreskowy",
                                label: "Kod kreskowy",
                                actionText: "Zatwierdź",
                                successMessage: "Pojazd został wpuszczony na teren portu",
                                errorMessage: " skanowania biletu",
                                invalidOrderStatus: "Niepoprawny status biletu. Bilet jest w statusie: {{value}}",
                                barcodeNoNotFound: "Nie znaleziono biletu o takim kodzie kreskowym."
                            }
                        },
                        order: {
                            title: "Ewidencja zleceń",
                            retrievalErrorSuffix: "pobierania ewidencji zleceń",
                            headers: {
                                status: "Status",
                                arrivalDepartureTime: "Czas przyjścia/odejścia",
                                relationType: "Relacja",
                                regNo: "Numer pojazdu",
                                trailerNo: "Numer naczepy",
                                shipownerName: "Armator",
                                ferry: "Prom",
                                info: "Info"
                            },
                            actions: {
                                tcr: "TCR",
                                tcrLong: "Stan naczepy (TCR)",
                                addOrder: "Zarejestruj zlecenie +",
                                modifyOrder: "Edytuj",
                                cancelOrder: "Anuluj",
                                allow: "Zezwól",
                                notAllow: "Nie zezwalaj",
                                modifyStatus: "Zmień status"
                            },
                            preview: {
                                header: "Zlecenie nr: {{number}}",
                                actions: {
                                    goBack: "Wróć do listy zleceń",
                                    details: "Szczegóły zlecenia",
                                    status: "Status",
                                    photos: "Zdjęcia"
                                },
                                retrievalErrorSuffix: "pobierania szczegółów zlecenia"
                            },
                            warningPopup: {
                                header: "Ostrzeżenie",
                                content1: "Wybrano długi okres czasu, może to spowodować spadek wydajności systemu.",
                                content2: "Czy na pewno chcesz wykonać to żądanie?",
                                actionText: "Tak"
                            },
                            details: {
                                general: {
                                    header: "Dane ogólne",
                                    properties: {
                                        status: "Status",
                                        relationType: "Relacja",
                                        cargoType: "Rodzaj ładunku",
                                        pinCode: "PIN",
                                        barcodeNo: "Kod kreskowy",
                                        currentRoute: "Bieżąca trasa",
                                        gateNo: "Numer bramy",
                                        createdAt: "Czas utworzenia"
                                    }
                                },
                                temperature: {
                                    header: "Temperatura",
                                    properties: {
                                        requestedTemp1: "Żądana temperatura 1",
                                        requestedTemp2: "Żądana temperatura 2"
                                    }
                                },
                                transportation: {
                                    header: "Transport",
                                    properties: {
                                        trailerRegNo: "Numer naczepy",
                                        transportCompany: "Firma transportowa",
                                        recipient: "Odbiorca",
                                        supplierLorryRegNo: "Nr ciągnika dostawcy",
                                        recipientLorryRegNo: "Nr ciągnika odbiorcy",
                                        lorryRegNo: "Nr ciągnika",
                                        provider: "Dostawca"
                                    }
                                },
                                voyage: {
                                    header: "Podróż",
                                    properties: {
                                        shipownerName: "Armator",
                                        voyageNo: "Numer podróży",
                                        arrivalDepartureTime: "Czas przybycia/wyjścia",
                                        ferryName: "Nazwa promu",
                                        originDestinationPort: "Port przeznaczenia/nadania",
                                        originDestinationCountry: "Kraj przeznaczenia/nadania",
                                        bookingNo: "Numer rezerwacji"
                                    }
                                },
                                cargo: {
                                    header: "Ładunek",
                                    properties: {
                                        cargoDesc: "Nazwa ładunku",
                                        weight: "Waga",
                                        length: "Długość",
                                        width: "Szerokość",
                                        height: "Wysokość",
                                        packingQuantity: "Liczba opakowań",
                                        cbm: "CBM",
                                        packing: "Opakowanie",
                                        remarks: "Uwagi",
                                        wagonRegNo: "Numer wagonu",
                                        supplierWagonRegNo: "Numer wagonu dostawcy",
                                        recipientWagonRegNo: "Numer wagonu odbiorcy",
                                        securingDeclaration: "Deklaracja sztauowania"
                                    }
                                },
                                container: {
                                    header: "Kontener",
                                    properties: {
                                        containerNo: "Numer kontenera",
                                        containerSize: "Rozmiar kontenera",
                                        vgm: "VGM"
                                    }
                                },
                                costs: {
                                    header: "Koszty",
                                    properties: {
                                        storageTime: "Czas składowania",
                                        chargeableTime: "Czas podlegający opłacie",
                                        paymentMethod: "Forma płatności",
                                        paymentWaiver: "Zwolnienie z opłaty",
                                        paymentDocumentNumber: "Numer dokumentu płatności",
                                        parkingCost: "Koszt postoju"
                                    }
                                },
                                dangerousGoods: {
                                    header: "Towary niebezpieczne",
                                    properties: {
                                        unCode: "Kod UN",
                                        packing: "Opakowanie",
                                        packingQuantity: "Liczba opakowań",
                                        packingGroup: "Kategoria opakowań",
                                        weight: "Waga"
                                    }
                                },
                                files: {
                                    exportOrderCargoFileName: "Zlecenie export CARGO-{{number}}",
                                    importOrderCargoFileName: "Zlecenie import CARGO-{{number}}",
                                    noSeaTrafficCargoFileName: "Zlecenie DEPO CARGO-{{number}}",
                                    transportType: {
                                        road: "pojazd",
                                        rail: "wagon"
                                    },
                                    importTrailerOrContainerOrderFileName: "Zlecenie import NACZEPA/KONTENER-{{number}}",
                                    exportTrailerOrContainerOrderFileName: "Zlecenie export NACZEPA/KONTENER-{{number}}",
                                    noSeaTrafficTrailerOrContainerFileName: "Zlecenie DEPO {{number}}",
                                    fileDownloadErrorSuffix: "generowania pliku",
                                    cancelOrderErrorSuffix: "anulowania zlecenia"
                                },
                                assignWagonsNumberPopup: {
                                    header: "Przypisz numer wagonu",
                                    contentPart1: "Wprowadź numer wybranego wagonu",
                                    contentPart2: "Pamiętaj, zanim zapiszesz sprawdź poprawność wpisanych danych.",
                                    assignWagonsNumberErrorSuffix: "przypisywania numeru wagonu"
                                }
                            },
                            tcr: {
                                header: "Zlecenie nr: {{number}}",
                                equipmentType: {
                                    TARPAULIN: "Plandeka",
                                    SIDE_BOARD: "Burta",
                                    LEG: "Noga",
                                    WHEEL: "Koło",
                                    LIGHT: "Światło",
                                    SPARE_WHEEL: "Koło zapasowe",
                                    WINCH: "Korba",
                                    PLUMB: "Plomba",
                                    WEDGE: "Kliny",
                                    AGGREGATE: "Agregat",
                                    BICYCLE_PROTECTION: "Ochrona rowerowa"
                                },
                                sections: {
                                    trailerCondition: {
                                        header: "Stan naczepy (TCR)",
                                        damageHeaders: {
                                            sideType: "Strona",
                                            damageUpdateTime: "Ostatnia modyfikacja",
                                            equipmentType: "Miejsce uszkodzenia",
                                            damageType: "Uszkodzenia",
                                            direction: ""
                                        },
                                        actions: {
                                            manage: "Zarządzaj",
                                        },
                                        sideType: {
                                            FRONT: "Front",
                                            REAR: "Tył",
                                            LEFT: "Lewy bok",
                                            RIGHT: "Prawy bok"
                                        },
                                        sideTypeFirstLetter: {
                                            FRONT: "F",
                                            REAR: "T",
                                            LEFT: "LB",
                                            RIGHT: "PB"
                                        },
                                        damageType: {
                                            SCRATCHED: "Odrapany",
                                            BENT: "Pogięty",
                                            TORN: "Podarty",
                                            LEAKAGE: "Wyciek",
                                            CRACKED: "Rozbity",
                                            BROKEN: "Połamany",
                                            DENT: "Wygięty",
                                            MISSING: "Brak",
                                            OUT_OF_ORDER: "Uszkodzony"
                                        },
                                        damageLocation: {
                                            LEFT_TOP: "lewa górna",
                                            RIGHT_TOP: "prawa górna",
                                            LEFT_BOTTOM: "lewa dolna",
                                            RIGHT_BOTTOM: "prawa dolna",
                                            FRONT: "Przednie",
                                            CENTER: "Środkowe",
                                            REAR: "Tylne"
                                        },
                                        modifyTrailerDamages: {
                                            header: "Lista uszkodzeń",
                                            saveButtonText: "OK",
                                            returnButtonText: "Powrót",
                                            headers: {
                                                direction: "Status",
                                                damageUpdateTime: "Data",
                                                code: "Kod",
                                                equipmentType: "Miejsce uszkodzenia",
                                                damageType: "Nazwa uszkodzenia"
                                            }
                                        }
                                    },
                                    additionalEquipment: {
                                        header: "Wyposażenie dodatkowe",
                                        quantity: "ilość"
                                    },
                                    temperature: {
                                        header: "Temperatura",
                                        labels: {
                                            actualTemp1: "Zmierzona 1",
                                            actualTemp2: "Zmierzona 2",
                                            requestedTemp1: "Żądana 1",
                                            requestedTemp2: "Żądana 2"
                                        }
                                    }
                                },
                                retrievalErrorSuffix: "pobierania TCR",
                                modifyErrorSuffix: "modyfikacji TCR",
                                file: {
                                    button: "Pobierz raport TCR",
                                    fileName: "Trailer Condition report {{number}}"
                                },
                                successFirstPart: "Udało się! ",
                                successSecondPart: "TCR zostało zapisane"
                            },
                            status: {
                                actualChipLabel: "Aktualny",
                                nextChipLabel: "Następny",
                                currentRouteLabel: "Aktualna trasa",
                                retrievalErrorSuffix: "pobierania statusu",
                                noStatus: "Nie dotyczy",
                                actions: {
                                    discard: "Odrzuć",
                                    allow: "Pozwól",
                                    allowWithTcr: "Przejdź do TCR"
                                },
                                discardPopup: {
                                    header: "Na pewno odrzucić?",
                                    secondHeader: "Nie zezwalaj na wjazd",
                                    content: "Czy na pewno chcesz odrzucić transport i skierować go do wyjazdu z terminala?",
                                    actionText: "Tak, odrzuć",
                                    discardErrorSuffix: "odrzucania transportu"
                                },
                                allowWithTcrRequiredPopup: {
                                    header: "Uzupełnij TCR",
                                    contentPart1: "Przejdź do TCR, aby uzupełnić dokument lub ",
                                    contentSkip: "Pomiń",
                                    contentPart2: " jeżeli transport ma zostać przyjęty bez wypełnienia ",
                                    contentTcrBold: "TCR.",
                                    actionText: "Pomiń",
                                    cancelText: "Przejdź do TCR",
                                    allowWithTcrRequiredErrorSuffix: "pomijania TCR"
                                },
                                allowWithLocationDepoPopup: {
                                    header: "Zezwól na wjazd",
                                    content: "Czy na pewno chcesz pozwolić na wjazd nr zlecenia: ",
                                    label: "Wybierz lokalizację",
                                    actionText: "Zezwól"
                                },
                                supervisorFlowActionsPopup: {
                                    header: "Zmień status",
                                    actionText: "Zmień",
                                    content: "Czy na pewno chcesz zmienić status zlecenia: ",
                                    availableStatusesErrorSuffix: "pobierania statusów",
                                    label: "Wybierz akcję",
                                    executeChangeStatusErrorSuffix: "zmiany statusu",
                                    actions: {
                                        GET_BACK_TO_REGISTRATION: "Cofnij do Rejestracja",
                                        GET_BACK_TO_PORT_ENTRANCE: "Cofnij do Parking wjazd",
                                        GET_BACK_TO_PORT_EXIT: "Cofnij do Parking wyjazd",
                                        GET_BACK_TO_DEPO_ENTRANCE: "Cofnij do Depo wjazd",
                                        GET_BACK_TO_DEPO_EXIT: "Cofnij do Depo wyjazd",
                                        GET_BACK_TO_FERRY_ENTRANCE: "Cofnij do Prom wjazd",
                                        GET_BACK_TO_FERRY_EXIT: "Cofnij do Prom wyjazd",
                                        CANCEL: "Anulowane",
                                        ENTER_PORT: "Parking wjazd",
                                        EXIT_PORT: "Parking wyjazd",
                                        ENTER_DEPO: "Depo wjazd",
                                        EXIT_DEPO: "Depo wyjazd",
                                        ENTER_FERRY: "Prom wjazd",
                                        EXIT_FERRY: "Prom wyjazd",
                                        CONFIRM_BY_MANIFEST: "Manifest",
                                        CANCEL_BY_MANIFEST: "Anulowane przez manifest"
                                    }
                                },
                                allowErrorSuffix: "potwierdzania transportu",
                                locationsErrorSuffix: "pobierania lokalizacji",
                                forbiddenError: "Operacja niedozwolona. Odśwież ekran.",
                            },
                            addOrder: {
                                header: "Dodaj nowe zlecenie",
                                saveButtonText: "Zarejestruj",
                                errors: {
                                    addErrorSuffix: "rejestracji nowego zlecenia",
                                    correctDateWithTime: "Niepoprawna data z czasem",
                                    pinCodeErrorMessage: "Pin powinien składać się z 5 nieujemnych cyfr",
                                    barcodeErrorMessage: "Kod kreskowy powinien składać się maksymalnie z 20 znaków"
                                },
                                httpErrors: {
                                    object: "zlecenie",
                                    pinCode: "numerze PIN",
                                    barcodeNo: "kodzie kreskowym",
                                    voyageNo: "numerze podróży",
                                    bookingNo: "numerze rezerwacji"
                                }
                            },
                            modifyOrder: {
                                header: "Edytuj zlecenie",
                                errors: {
                                    retrievalErrorSuffix: "pobierania zlecenia",
                                    modifyErrorSuffix: "edycji zlecenia",
                                }
                            },
                            photos: {
                                header: "Zlecenie nr: {{number}}",
                                subHeader: "Zdjęcia",
                                headers: {
                                    sideType: "Strona",
                                    createdAt: "Godz i data wykonania",
                                    direction: ""
                                },
                                actions: {
                                    viewPhoto: "Zobacz zdjęcie",
                                },
                                sideType: {
                                    FRONT: "Front",
                                    REAR: "Tył",
                                    LEFT: "Lewy bok",
                                    RIGHT: "Prawy bok",
                                    TOP: "Góra"
                                },
                                sideTypeFirstLetter: {
                                    FRONT: "F",
                                    REAR: "T",
                                    LEFT: "LB",
                                    RIGHT: "PB",
                                    TOP: "G"
                                },
                                imageAlt: "Zdjęcie {{sideType}}",
                                retrievalErrorSuffix: "pobierania zdjęć",
                                imageNotFoundError: "Wczytywanie zdjęcia nie powiodło się. Spróbuj ponownie później."
                            }
                        }
                    },
                    topology: {
                        title: "Topologia portu",
                        locations: {
                            title: "Lokalizacje",
                            actions: {
                                addLocation: {
                                    button: "Dodaj lokalizację +",
                                    header: "Dodaj nową lokalizację"
                                },
                                modifyLocation: {
                                    button: "Modyfikuj",
                                    header: "Modyfikacja lokalizacji"
                                },
                            },
                            headers: {
                                apiKey: "Klucz API",
                                locationType: "Typ",
                                url: "Adres url",
                                name: "Lokalizacja",
                                description: "Opis"
                            },
                            locationType: {
                                ENTRY_TERMINAL: "Terminal wjazdowy",
                                EXIT_TERMINAL: "Terminal wyjazdowy",
                                PHOTOSHOOTER: "Photoshooter",
                                LIGHTBOARD: "Tablica zmiennej treści",
                                PARKING: "Parking",
                                WHARF: "Nabrzeże",
                                NO_AUTOMATION: "Bez automatyki"
                            },
                            errors: {
                                retrievalErrorSuffix: "pobierania lokalizacji",
                                addErrorSuffix: "dodawania nowej lokalizacji",
                                invalidUrl: "Niepoprawny adres url",
                                apiKeyCorrectLength: "Klucz API musi mieć przynajmniej 32 znaki",
                                modifyErrorSuffix: "modyfikacji lokalizacji",
                                selectedLocationErrorSuffix: "pobierania wybranej lokalizacji",
                                removeErrorSuffix: "usuwania lokalizacji"
                            },
                            httpErrors: {
                                object: "lokalizacja",
                                apiKey: "kluczu API",
                                locationType: "typie",
                                url: "adresie url",
                                name: "nazwie",
                                apiKeyEmpty: "klucz API",
                                locationTypeEmpty: "typ",
                                urlEmpty: "adres url",
                                nameEmpty: "nazwa"
                            },
                            checkboxLabel: {
                                openParking: "Otwarcie parkingu",
                                startLoading: "Rozpoczęcie załadunku"
                            },
                            removeAction: {
                                header: "Czy na pewno chcesz usunąć lokalizację?",
                                secondHeader: "Usuń lokalizację",
                                actionText: "Tak, usuń",
                                line1: "Czy na pewno chcesz usunąć lokalizację?",
                                line2: "Tej akcji nie można cofnąć!"
                            }
                        },
                        routes: {
                            title: "Trasy",
                            headers: {
                                name: "Nazwa trasy",
                                isActive: "Status",
                                supportedRelationTypes: "Rodzaj biletu/zlecenia",
                                supportedCargoTypes: "Rodzaj ładunku",
                                wayPoints: "Lokalizacja",
                                location: "Lokalizacja",
                                basicRoute: "Trasa podstawowa",
                                alternativeRoute: "Trasa alternatywna",
                                sign: "Znak trasy podstawowej",
                                alternativeSign: "Znak tarsy alternatywnej"
                            },
                            actions: {
                                activeAction: "Aktywuj",
                                activePopup: {
                                    header: "Czy na pewno chcesz aktywować trasę?",
                                    secondHeader: "Aktywuj trasę",
                                    contentPart1: "Czy na pewno chcesz aktywować trasę o nazwie ",
                                    contentPart2: " ? Tą akcję można cofnąć.",
                                    actionText: "Tak, aktywuj",
                                    errorSuffix: "aktywacji trasy"
                                },
                                inactiveAction: "Dezaktywuj",
                                inactivePopup: {
                                    header: "Czy na pewno chcesz dezaktywować trasę?",
                                    secondHeader: "Dezaktywuj trasę",
                                    contentPart1: "Czy na pewno chcesz dezaktywować trasę o nazwie ",
                                    contentPart2: " ? Tą akcję można cofnąć.",
                                    actionText: "Tak, dezaktywuj",
                                    errorSuffix: "dezaktywacji trasy"
                                },
                                removeAction: "Usuń",
                                removePopup: {
                                    header: "Czy na pewno chcesz usunąć trasę?",
                                    secondHeader: "Usuń trasę",
                                    contentPart1: "Czy na pewno chcesz usunąć trasę o nazwie ",
                                    contentPart2: " ? Tej akcji nie można cofnąć!",
                                    actionText: "Tak, usuń",
                                    errorSuffix: "usuwania trasy"
                                },
                                addRoute: {
                                    button: "Dodaj trasę +",
                                    header: "Dodaj nową trasę"
                                },
                                modifyRoute: {
                                    button: "Modyfikuj",
                                    header: "Modyfikacja trasy"
                                }
                            },
                            errors: {
                                retrievalErrorSuffix: "pobierania tras",
                                oneOrMoreSelectedError: "Przynajmniej jeden rodzaj musi być zaznaczony",
                                addErrorSuffix: "dodawania nowej trasy",
                                modifyErrorSuffix: "modyfikacji trasy",
                                downloadDataErrorSuffix: "pobierania danych do formularza",
                                selectedRouteErrorSuffix: "pobierania wybranej trasy"
                            },
                            httpErrors: {
                                object: "trasa",
                                name: "nazwie",
                                nameEmpty: "nazwa trasy",
                                supportedRelationTypesEmpty: "rodzaj biletu/zlecenia",
                                supportedCargoTypesEmpty: "rodzaj ładunku",
                                locationIdEmpty: "lokalizacja",
                                signEmpty: "znak trasy podstawowej",
                                alternativeSignEmpty: "znak trasy alternatywnej"
                            }
                        }
                    },
                    documents: {
                        title: "Dokumenty",
                        retrievalErrorSuffix: "pobierania dokumentów",
                        generalDeclaration: {
                            title: "Generalna Deklaracja",
                            filters: {
                                arrivalDepartureTime: "Przybycie/wyjście",
                                type: "Typ",
                                shipowner: "Armator",
                                ferry: "Prom"
                            },
                            headers: {
                                directionType: "Typ",
                                shipownerName: "Armator",
                                ferryName: "Prom",
                                ferryImoCode: "Numer IMO statku",
                                voyageNo: "Nr podróży",
                                arrivalDeparturePort: "Port przybycia/wyjścia",
                                arrivalDepartureTime: "Czas przybycia/wyjścia",
                                originDestinationPort: "Poprzedni/następny port"
                            },

                            preview: "Zobacz",
                            details: {
                                header: "Numer {{number}}",
                                retrievalErrorSuffix: "pobierania szczegółów generalej deklaracji",
                                files: {
                                    failedGenerate: "Nie udało się wygenerować pliku",
                                    generalDeclaration: {
                                        button: "Drukuj generalną deklarację do pliku",
                                        fileName: "Generalna deklaracja nr {{number}}"
                                    },
                                    manifest: {
                                        button: "Drukuj manifest do pliku",
                                        fileName: "Manifest dla generalnej deklaracji nr {{number}}"
                                    }
                                },
                                general: {
                                    properties: {
                                        ferryName: "Prom",
                                        ferryImoCode: "Numer IMO statku",
                                        shipownerName: "Armator",
                                        shipownerImoCode: "Numer IMO Armatora",
                                        voyageNo: "Nr podróży",
                                        ssDraft: "Zanurzenie statku",
                                        totalWeight: "Łączna waga",
                                        arrivalDeparturePort: "Port przybycia/wyjścia",
                                        arrivalDepartureTime: "Czas przybycia/wyjścia",
                                        originDestinationPort: "Poprzedni/następny port",
                                        wharfDesc: "Miejsce postoju w porcie",
                                        passengersNumber: "Liczba pasażerów",
                                        briefOfVoyage: "Dane podróży",
                                        marineHealthDeclaration: "Morska deklaracja o stanie zdrowia",
                                        remarks: "Uwagi"
                                    }
                                },
                                manifests: {
                                    header: "Manifesty",
                                    properties: {
                                        version: "Wersja",
                                        bookingNo: "Nr biletu",
                                        arrivalDepartureTime: "Czas przybycia/wyjścia",
                                        loadingType: "Typ ładunku",
                                        cargoDesc: "Opis typu ładunku",
                                        lorryRegNo: "Numer ciągnika",
                                        trailerRegNo: "Numer naczepy",
                                        containerNo: "Numer kontenera"
                                    }
                                }
                            },
                            errors: {
                                manifestNotFound: "Nie znaleziono manifestu o numerze {{number}}"
                            }
                        },
                        manifests: {
                            title: "Manifesty",
                            filters: {
                                version: "Wersja",
                                type: "Typ",
                                shipowner: "Armator",
                                voyageNo: "Numer podróży"
                            },
                            headers: {
                                version: "Wersja",
                                directionType: "Typ",
                                shipownerName: "Armator",
                                ferryName: "Nazwa statku",
                                voyageNo: "Nr podróży",
                                bookingNo: "Nr biletu",
                                arrivalDepartureTime: "Czas przybycia/wyjścia",
                                loadingType: "Typ ładunku",
                                cargoDesc: "Opis typu ładunku"
                            },
                            preview: "Zobacz",
                            details: {
                                header: "Nr {{number}}",
                                retrievalErrorSuffix: "wczytywania szczegółów manifestu",
                                properties: {
                                    ferryName: "Prom",
                                    ferryImoCode: "Numer IMO Statku",
                                    shipownerImoCode: "Numer IMO Armatora",
                                    voyageNo: "Numer podróży",
                                    arrivalDepartureTime: "Czas przybycia/wyjścia",
                                    bookingNo: "Numer rezerwacji",
                                    loadingType: "Typ ładunku",
                                    lorryRegNo: "Numer ciągnika",
                                    trailerRegNo: "Numer naczepy",
                                    length: "Długość ładunku",
                                    cargoDesc: "Nazwa ładunku",
                                    weight: "Waga ładunku",
                                    plugin: "Podłączenie (plugin)",
                                    imdgClass: "Klasa IMDG",
                                    payableBy: "Płatny przez",
                                    shipperName: "Spedytor drogowy",
                                    originCountry: "Kraj załadunku",
                                    destinationCountry: "Kraj rozładunku",
                                    overwide: "Ładunek ponadgabarytowy",
                                    freight: "Fracht",
                                    currency: "Waluta",
                                    containerNo: "Numer kontenera",
                                    containerSize: "Rozmiar kontenera",
                                    vgm: "Waga VGM",
                                    billOfLading: "Konosament"
                                }
                            }
                        }
                    },
                    alerts: {
                        title: "Alerty",
                        retrievalErrorSuffix: "wczytywania alertów",
                        readErrorSuffix: "oznaczania alertu {{id}} jako przeczytany",
                        resolveErrorSuffix: "oznaczania alertu {{id}} jako rozwiązany",
                        status: {
                            not: "nie ",
                            isRead: "przeczytano",
                            isResolved: "rozwiązano"
                        },
                        actions: {
                            read: "Przeczytaj",
                            resolve: "Rozwiąż alert",
                        },
                        property: {
                            date: "Data",
                            location: "Lokalizacja",
                            orderNo: "Nr zlecenia",
                            ticketNo: "Nr biletu",
                            trailerRegNo: "Naczepa",
                            lorryRegNo: "Ciągnik",
                            wagonNo: "Wagon",
                            bookingNo: "Numer rezerwacji",
                            containerNo: "Kontener"
                        },
                        notifications: {
                            PHOTOS_NOT_TAKEN: "Nie wykonano zdjęć",
                            VEHICLE_RECOGNIZED_AND_NOT_ASSIGNED_TO_ORDER: "Rozpoznano pojazd, nie przypisano do biletu/zlecenia",
                            VEHICLE_NOT_RECOGNIZED: "Nie rozpoznano pojazdu",
                            TICKET_REGISTERED_NEAR_END_OF_LOADING_TIME: "Armator wprowadził bilet na {{time}} min przed zakończeniem załadunku promu",
                            ORDER_REGISTERED_NEAR_END_OF_LOADING_TIME: "Armator wprowadził zlecenie na {{time}} min przed zakończeniem załadunku promu",
                            VEHICLE_ENTERED_JUST_BEFORE_PARKING_CLOSE: "Pojazd wjechał do portu na {{time}} min przed zakończeniem załadunku promu",
                            VEHICLE_ATTEMPTED_ENTRANCE_AFTER_END_OF_LOADING: "Próba wjazdu pojazdu po czasie zakończenia załadunku",
                            VEHICLE_AUTHORIZED_UNSUCCESSFULLY: "Nieudana autoryzacja podczas próby przejazdu pojazdu",
                            ORDER_ENTERED_PORT: "Zmiana statusu na Parking wjazd",
                            ORDER_ENTERED_DEPO: "Zmiana statusu na Depo wjazd",
                            ORDER_ENTERED_FERRY: "Zmiana statusu na Prom wjazd",
                            ORDER_EXITED_DEPO: "Zmiana statusu na Depo wyjazd",
                            ORDER_EXITED_PORT: "Zmiana statusu na Parking wyjazd",
                            ORDER_EXITED_FERRY: "Zmiana statusu na Prom wyjazd",
                            ORDER_CANCELED: "Zmiana statusu na Anulowany",
                            ORDER_CONFIRMED_BY_MANIFEST: "Zmiana statusu na Manifest",
                            NEAR_TIME_TO_FERRY_DEPARTURE: "Prom dla zlecenia odpływa za {{time}} min"
                        },
                        newAlerts: {
                            header: "Nowe alerty: ",
                            allAlerts: "Zobacz wszystkie alerty",
                            date: "Data"
                        }
                    },
                    place: {
                        title: "Zarządzanie placem",
                        lightBoards: {
                            title: "Tablice zmiennej treści",
                            retrievalErrorSuffix: "wczytywania tablic zmiennej treści",
                            manualOperatingSign: "Znak",
                            headers: {
                                location: "Lokalizacja",
                                operatingMode: "Tryb pracy",
                                currentMessage: "Aktualny komunikat trybu manualnego"
                            },
                            actions: {
                                changeToManualMode: "Wyślij komunikat do tablicy",
                                changeToAutoMode: "Włącz tryb automatyczny",
                            },
                            operatingModes: {
                                MANUAL: "Manualny",
                                AUTO: "Automatyczny"
                            },
                            manualOperatingPopup: {
                                header: "Komunikat trybu manualnego",
                                manualOperatingMessage: "Komunikat",
                                manualOperatingSign: "Kod znaku",
                                required: "Przynajmniej jedno z pól musi być wypełnione"
                            },
                            signCodes: {
                                LEFT_TURN: "Nakaz skrętu w lewo",
                                RIGHT_TURN: "Nakaz skrętu w prawo",
                                AHEAD: "Nakaz jazdy prosto",
                                NO_ENTRY: "Zakaz wjazdu"
                            },
                            changeMessageErrorSuffix: "zmiany trybu pracy tablicy",
                            sendMessageErrorSuffix: "wysyłania komunikatu"
                        },
                        ownedVehicles: {
                            title: "Pojazdy własne",
                            retrievalErrorSuffix: "wczytywania pojazdów własnych",
                            headers: {
                                regNo: "Numer rejestracyjny",
                                usedBy: "Login użytkownika",
                                orderNo: "Numer zlecenia",
                                lastLocation: "Ostatnia lokalizacja"
                            },
                            orderDetailAction: "Wyświetl szczegóły zlecenia"
                        },
                        ferryOrdersParkings: {
                            title: "Parkingi zleceń promowych",
                            retrievalErrorSuffix: "wczytywania parkingów dla zleceń promowych",
                            headers: {
                                relationType: "Typ zlecenia",
                                totalNumberOfOrders: "Liczba zleceń",
                                numberOfOrdersInDepo: "Wjechało na Depo",
                                numberOfOrdersExitedDepo: "Wyjechało z Depo",
                                ferryName: "Prom",
                                arrivalDepartureTime: "Czas przybycia/wyjścia"
                            }
                        },
                        nonFerryOrdersParkings: {
                            title: "Parkingi zleceń bezpromowych",
                            retrievalErrorSuffix: "wczytywania parkingów dla zleceń bezpromowych",
                            headers: {
                                relationType: "Typ zlecenia",
                                totalNumberOfOrders: "Liczba zleceń",
                                numberOfOrdersInDepo: "Wjechało na Depo",
                                numberOfOrdersExitedDepo: "Wyjechało z Depo",
                            }
                        },
                        entryOrExit: {
                            title: "Wjazd/Wyjazd",
                            headers: {
                                name: "Lokalizacja",
                                description: "Opis lokalizacji",
                                actions: "Pozwolenie na wjazd/wyjazd"
                            },
                            actions: {
                                notAllow: "Nie zezwalaj",
                                allow: "Zezwalaj",
                                openAll: "Otwórz wszystko",
                                closeAll: "Zamknij wszystko"
                            },
                            openAllPopup: {
                                header: "Otwórz wszystko",
                                content: "Czy na pewno chcesz otworzyć wszystkie urządzenia podłączone pod kiosk ",
                                errorSuffix: "otwierania wszystkich urządzeń podłączonych pod kiosk",
                            },
                            closeAllPopup: {
                                header: "Zamknij wszystko",
                                content: "Czy na pewno chcesz zamknąć wszystkie urządzenia podłączone pod kiosk ",
                                errorSuffix: "zamykania wszystkich urządzeń podłączonych pod kiosk"
                            },
                            errors: {
                                retrievalErrorSuffix: "wczytywania listy lokalizacji"
                            }
                        }
                    },
                    reports: {
                        title: "Raporty",
                        filterButton: "Generuj raport",
                        downloadButton: "Pobierz raport",
                        downloadSummaryReportButton: "Pobierz podsumowanie",
                        generatedReport: "Wygenerowany raport",
                        generatedSummaryReport: "Podsumowanie",
                        seaFerriesSummary: {
                            title: "Zestawienie promów morskich",
                            filters: {
                                year: "Rok",
                                month: "Miesiąc"
                            },
                            headers: {
                                shipownerName: "Nazwa armatora",
                                ferryName: "Prom",
                                loadingType: "Typ ładunku",
                                billOfLading: "Konosament",
                                monthOut: "Miesiąc OUT",
                                monthIn: "Miesiąc IN",
                                calculatedMonth: "Miesiąc razem",
                                yearOut: "Rok OUT",
                                yearIn: "Rok IN",
                                calculatedYear: "Rok razem"
                            }
                        },
                        transportRegister: {
                            title: "Rejestr przewozów",
                            filters: {
                                arrivalFerryFrom: "Przybycie promu: Od",
                                arrivalFerryTo: "Przybycie promu: Do",
                                departureFerryFrom: "Wyjście promu: Od",
                                departureFerryTo: "Wyjście promu: Do",
                                shipowner: "Armator",
                                ferry: "Prom",
                                wharf: "Numer nabrzeża",
                                originDestinationPort: "Port nadania/przeznaczenia",
                                actionType: "Relacja"
                            },
                            headers: {
                                ferryName: "Prom",
                                shipownerName: "Armator",
                                directionType: "Relacja",
                                voyageNo: "Numer podróży przybycia/wyjścia",
                                arrivalDepartureTime: "Planowany czas przybycia/wyjścia promu",
                                wharf: "Numer nabrzeża",
                                originDestinationPort: "Port nadania/port przeznaczenia",
                                numberOfLorryTrailers: "Ciągniki z naczepą",
                                numberOfTrailers: "Naczepy",
                                numberOfCars: "Samochody",
                                numberOfBuses: "Autobusy",
                                numberOfRailways: "Wagony",
                                numberOfGeneralCargos: "Ładunki (drobnica)",
                                numberOfContainers: "Kontenery",
                                vgmSum: "Waga VGM kontenerów",
                                numberOfOthers: "Pozostałe"
                            }
                        },
                        ferryHandlingTime: {
                            title: "Czas obsługi promu",
                            filters: {
                                arrivalFerryFrom: "Przybycie promu: Od",
                                arrivalFerryTo: "Przybycie promu: Do",
                                departureFerryFrom: "Wyjście promu: Od",
                                departureFerryTo: "Wyjście promu: Do",
                                ferry: "Prom",
                                actionType: "Typ operacji",
                                voyageNo: "Numer podróży",
                            },
                            headers: {
                                ferryName: "Prom",
                                actionType: "Typ operacji",
                                voyageNo: "Numer podróży",
                                firstEntryToTerminal: "Pierwszy wjazd do terminala",
                                lastEntryToTerminal: "Ostatni wjazd do terminala",
                                entryTimeDifference: "Różnica",
                                scheduledArrivalTimeOfFerry: "Planowany czas przybycia promu",
                                actualArrivalTimeOfFerry: "Rzeczywisty czas przybycia promu",
                                differenceArrivalTime: "Różnica",
                                scheduledDepartureTimeOfFerry: "Planowany czas zwolnienia nabrzeża",
                                actualDepartureTimeOfFerry: "Rzeczywisty czas zwolnienia nabrzeża",
                                differenceDepartureTime: "Różnica",
                                notes: "Uwagi"
                            }
                        },
                        vehicleOrCargoHandlingTime: {
                            title: "Czas obsługi pojazdu/ładunku",
                            filters: {
                                bookingNo: "Numer rezerwacji",
                                lorryRegNo: "Numer ciągnika",
                                trailerRegNo: "Numer naczepy",
                                containerNo: "Numer kontenera",
                                wagonRegNo: "Numer wagonu",
                                dateFrom: "Czas od:",
                                dateTo: "Czas do:"
                            },
                            headers: {
                                bookingNo: "Numer rezerwacji",
                                lorryRegNo: "Numer ciągnika",
                                trailerRegNo: "Numer naczepy",
                                containerNo: "Numer kontenera",
                                wagonRegNo: "Numer wagonu",
                                location: "Punkt trasy",
                                orderStatus: "Status biletu/zlecenia",
                                createdAt: "Czas zdarzenia",
                                ferryName: "Nazwa promu",
                                timeBetweenEvents: "Czas między zdarzeniami",
                                timeBetweenEventsCumulatively: "Czas między zdarzeniami narastająco"
                            },
                            locationType: {
                                PORT: "Port",
                                DEPO: "Depo",
                                FERRY: "Prom",
                                PHOTOSHOOTER: "Photoshooter"
                            }
                        },
                        invoiceAttachment: {
                            title: "Załącznik do faktury",
                            filters: {
                                dateFrom: "Data od:",
                                dateTo: "Data do:",
                                ferry: "Prom"
                            },
                            headers: {
                                ferryName: "Prom",
                                directionType: "Relacja",
                                voyageNo: "Numer podróży przybycia/wyjścia",
                                arrivalDepartureTime: "Planowany czas przybycia/wyjścia promu",
                                numberOfPassengers: "Pasażerowie",
                                numberOfDrivers: "Kierowcy",
                                numberOfLorries: "Ciągniki z naczepą",
                                numberOfTrailers: "Naczepy",
                                numberOfCars: "Samochody osobowe",
                                numberOfBuses: "Autobusy",
                                numberOfWagons: "Wagony",
                                numberOfContainers: "Kontenery",
                                numberOfGeneralCargos: "Drobnica",
                                numberOfOthers: "Pozostałe",
                                numberOfBillOfLading: "Konosament"
                            }
                        },
                        dangerousGoodsRegister: {
                            title: "Rejestr materiałów niebezpiecznych",
                            filters: {
                                arrivalFerryFrom: "Przybycie promu: Od",
                                arrivalFerryTo: "Przybycie promu: Do",
                                departureFerryFrom: "Wyjście promu: Od",
                                departureFerryTo: "Wyjście promu: Do",
                                shipowner: "Armator",
                                ferry: "Prom",
                                voyageNo: "Numer podróży",
                                unCode: "Kod UN",
                                packing: "Opakowanie"
                            },
                            headers: {
                                ferryName: "Prom",
                                shipownerName: "Armator",
                                directionType: "Relacja",
                                voyageNo: "Numer podróży przybycia/wyjścia",
                                arrivalDepartureTime: "Planowany czas przybycia/wyjścia promu",
                                actualArrivalDepartureTime: "Rzeczywisty czas przybycia/wyjścia promu",
                                cargoType: "Rodzaj ładunku",
                                lorryRegNo: "Numer ciągnika",
                                regNo: "Identyfikator ładunku",
                                unCodeValue: "ID kodu UN",
                                unCodeName: "Nazwa kodu UN",
                                imdgClass: "Klasa IMDG",
                                packingName: "Opakowanie",
                                packingQuantity: "Ilość opakowań",
                                packingGroup: "Kategoria opakowań",
                                weight: "Waga towaru niebezpiecznego"
                            }
                        },
                        trailerBase: {
                            title: "Baza naczep",
                            filters: {
                                depoEntryDateFrom: "Data złożenia: Od",
                                depoEntryDateTo: "Data złożenia: Do",
                                depoExitDateFrom: "Data podjęcia: Od",
                                depoExitDateTo: "Data podjęcia: Do",
                                bookingDateFrom: "Data rezerwacji: Od",
                                bookingDateTo: "Data rezerwacji: Do",
                                cargoType: "Rodzaj ładunku",
                                shipper: "Firma transportowa",
                                paymentWaiver: "Zwolniony z płatności",
                                ferry: "Prom",
                                relationType: "Relacja",
                                voyageNo: "Numer podróży"
                            },
                            headers: {
                                relationType: "Typ biletu/zlecenia",
                                cargoType: "Rodzaj ładunku",
                                orderStatus: "Status biletu/zlecenia",
                                ferryName: "Prom",
                                shipownerName: "Armator",
                                depoEntryDate: "Data złożenia",
                                depoExitDate: "Data podjęcia",
                                bookingDate: "Data rezerwacji",
                                trailerRegNo: "Numer naczepy",
                                lorryRegNo: "Numer ciągnika",
                                shipperName: "Firma transportowa",
                                storageTime: "Czas składowania",
                                billableStorageTime: "Czas składowania podlegający opłacie",
                                paymentMethod: "Forma płatności",
                                paymentWaiver: "Zwolniony z płatności",
                                weight: "Waga ładunku",
                                securingDeclaration: "Deklaracja sztauowania",
                                parkingCost: "Koszt postoju"
                            },

                        },
                        listOfShipments: {
                            title: "Zestawienie wysyłek",
                            filters: {
                                arrivalFerryFrom: "Przybycie promu: Od",
                                arrivalFerryTo: "Przybycie promu: Do",
                                departureFerryFrom: "Wyjście promu: Od",
                                departureFerryTo: "Wyjście promu: Do",
                                shipowner: "Armator",
                                ferry: "Prom",
                                relationType: "Typ biletu/zlecenia",
                                cargoType: "Rodzaj ładunku",
                                orderStatus: "Status biletu/zlecenia",
                                onlySummary: "Tylko podsumowanie"
                            },
                            headers: {
                                relationType: "Typ biletu/zlecenia",
                                cargoType: "Rodzaj ładunku",
                                orderStatus: "Status biletu/zlecenia",
                                bookingNo: "Numer rezerwacji",
                                ferryName: "Prom",
                                shipownerName: "Armator",
                                directionType: "Relacja",
                                voyageNo: "Nr podróży przybycia/wyjścia",
                                arrivalDepartureTime: "Planowany czas przybycia/wyjścia promu",
                                actualArrivalDepartureTime: "Rzeczywisty czas przybycia/wyjścia promu",
                                originDestinationPort: "Port nadania/port przeznaczenia",
                                lorryRegNo: "Numer ciągnika",
                                trailerRegNo: "Numer naczepy",
                                containerNo: "Numer kontenera",
                                wagonRegNo: "Numer wagonu",
                                weight: "Waga ładunku",
                                numberOfOrders: "Ilość biletów/zleceń"
                            },
                            errors: {
                                oneDateRequired: "Jedna z dat musi być podana"
                            }
                        },
                        actions: {
                            download: {
                                header: "Wybierz format pliku",
                                actionText: "Pobierz"
                            }
                        },
                        errors: {
                            downloadErrorSuffix: "pobierania raportu",
                            correctDateWithTime: "Niepoprawna data z czasem",
                            generateReportErrorSuffix: "generowania raportu",
                            generateSummaryReportErrorSuffix: "generowania podsumowania raportu",
                            downloadSummaryReportErrorSuffix: "pobierania podsumowania raportu",

                        }
                    },
                    priceList: {
                        title: "Cenniki",
                        retrievalErrorSuffix: "wczytywania cenników",
                        headers: {
                            priceListType: "Relacja",
                            startDate: "Data obowiązywania",
                            parkingTime: "Czas postoju (H)",
                            parkingFee: "Stawka (PLN/24H)",
                            validFrom: "Ważny od"
                        },
                        actions: {
                            addPrice: "Dodaj cennik +",
                            modifyPrice: "Edytuj",
                            addNextPriceList: "Dodaj kolejny +",
                        },
                        addPrice: {
                            header: "Dodaj nowy cennik",
                            saveButtonText: "Dodaj",
                        },
                        errors: {
                            getPriceErrorSuffix: "pobierania cennika",
                            addErrorSuffix: "dodawania nowego cennika",
                            editErrorSuffix: "edycji cennika",
                            dateValidFrom: "Data musi być w przyszłości",
                            isOneFreeTime: "Nie można wprowadzić kolejnego czasu wolnego od opłat",
                            hasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber: "Niepoprawny format lub liczba ujemna",
                            isMultipleTimes: "Czas postoju musi być wielokrotnością liczby 24",
                            numberGreaterThanZero: "Liczba musi być większa od 0",
                            freeParkingRateAtIncorrectPosition: "Darmowy czas nie jest pierwszą pozycją"
                        },
                        removePriceList: {
                            header: "Czy na pewno chcesz usunąć {{value}}?",
                            price: "cennik",
                            parkingRate: "czas postoju ze stawką",
                            secondHeader: "Usuń {{value}}",
                            actionText: "Tak, usuń",
                            line1: "Czy na pewno chcesz usunąć {{value}}?",
                            line2: "Tej operacji nie można cofnąć!",
                            errorMessagePart1: "usuwania cennika"
                        }
                    }
                }
            },
            en: {
                translation: {
                    defaultErrorMessage: "Error occurred during {{messageSuffix}}.\nTry again later.",
                    defaultNoDataLoadErrorMessage: "Error occurred during {{messageSuffix}}.\nTry refreshing the list with the button next to it.",
                    mappedErrorMessage: "Error occurred during {{cause}}",
                    mappedErrorMessageAlreadyExist: "{{object}} with {{property}} is {{value}} already exists",
                    mappedErrorMessageIsEmpty: "field {{propertyForEmpty}} field cannot be empty",
                    mappedErrorMessageWharfOccupied: "wharf is occupied at given time",
                    mappedErrorMessageFerryTaken: "ferry is taken at given time",
                    mappedErrorMessageVoyageNoAndTypeAlreadyExists: "{{type}} operation for voyage no {{voyageNo}} already exists",
                    mappedErrorMessageDateInvalid: "{{earlierTimeField}} cannot be later than {{laterTimeField}}",
                    mappedErrorMessageCannotUpdate: "a ticket or order has already been registered for this journey",
                    mappedErrorMessageRouteNotFound: "route has been deleted",
                    mappedErrorMessageInvalidOrderStatus: "edit operation is not allowed",
                    mappedErrorMessageBookingNoRejected: "the booking number already exists in the system",
                    mappedErrorMessageTimetableNotMatched: "the schedule action for the given ticket or order could not be found in the system",
                    mappedErrorMessageVoyageNumberAlreadyAssigned: "voyage number cannot be matched to schedule action",
                    mappedErrorMessageVoyageNumberTaken: "the voyage number is already assigned to another schedule action",
                    mappedErrorMessageUnknownShipownerNumber: "no shipowner with this IMO code found",
                    mappedErrorMessageUnknownFerryNumber: "ferry not found",
                    mappedErrorMessageUnknownUnCode: "UN code unknown",
                    mappedErrorMessageUnknownOriginDestinationPort: "the port is unknown",
                    mappedErrorMessageUnknownOriginDestinationCountry: "country is unknown",
                    mappedErrorMessageWagonAlreadyAssigned: "wagon number already assigned to order",
                    mappedErrorMessageCannotCancel: "there is an order that is currently being processed",
                    mappedErrorMessageInvalidOrderState: "transit cannot be handled. Passage not allowed",
                    mappedErrorMessagePinRejected: "the PIN was rejected",
                    mappedErrorMessageBarcodeNoRejected: "Barcode number cannot be assigned. The code already exists in the system",
                    mappedErrorMessagePriceListWithSameTypeAndDate: "price list no {{value}}: the given relation and date have already been used",
                    mappedErrorMessageLocationInUse: "cannot remove location which is in use",
                    mappedErrorMessageInvalidLocationType: "cannot remove location in given type",
                    errorMessages: {
                        required: "Field required",
                        dateIsNumber: "The date should consist of digits in the format mm/dd/yyyy",
                        correctDate: "Invalid date",
                        dateFromIsEarlierThanDateTo: "The date from cannot be later from the date to",
                        onlyNumber: "The field accepts only non-negative numbers",
                        correctTemperature: "Invalid temperature value",
                        correctTime: "Invalid hour",
                        actionNo: "Action no {{value}}:",
                        atLeastOneFilled: "At least one must be completed",
                        ferriesErrorSuffix: "downloading ferries",
                        shipownersErrorSuffix: "downloading shipowners",
                        wharfsErrorSuffix: "wharfs retrieval",
                        portsErrorSuffix: "downloading ports",
                        relationTypeErrorSuffix: "downloading types of tickets/orders",
                        companiesErrorSuffix: "downloading companies",
                        packingErrorSuffix: "downloading packages",
                        unCodesErrorSuffix: "downloading UN codes",
                        whrafsErrorSuffix: "whrafs retrieval",
                        routesErrorSuffix: "route download",
                        locationsErrorSuffix: "download location",
                        signCodesErrorSuffix: "downloading sign codes",
                        cargoTypesErrorSuffix: "load types",
                        countriesErrorSuffix: "download countries",
                        statusesErrorSuffix: "downloading statuses"
                    },
                    yes: "Yes",
                    no: "No",
                    remove: "Remove",
                    modify: "Modify",
                    preview: "Preview",
                    reloadMessage: "Reload",
                    more: "More",
                    menu: "Menu",
                    printToFile: "Print to file",
                    assignWagonsNumberBtn: "Assign a wagon number",
                    weekdays: {
                        monday: "Monday",
                        tuesday: "Tuesday",
                        wednesday: "Wednesday",
                        thursday: "Thursday",
                        friday: "Friday",
                        saturday: "Saturday",
                        sunday: "Sunday"
                    },
                    months: {
                        january: "January",
                        february: "February",
                        march: "March",
                        april: "April",
                        may: "May",
                        june: "June",
                        july: "July",
                        august: "August",
                        september: "September",
                        october: "October",
                        november: "November",
                        december: "December"
                    },
                    cancel: "Cancel",
                    save: "Save",
                    add: "Add",
                    dateFormat: "MM/DD/yyyy",
                    dateFormatWithTime: "MM/DD/yyyy hh:mm a",
                    timeWithDateFormat: "hh:mm a-MM/DD/yyyy",
                    priceFormat: "0.00",
                    pageable: {
                        rowsPerPageLabel: "Rows per page",
                        labelDisplayedRows: "of",
                        arriaLabel: "Go to {{type}} page",
                        arialLabelNext: "next",
                        arialLabelBack: "previous",
                        arialLabelFirst: "first",
                        arialLabelLast: "last",
                    },
                    userMenu: {
                        logout: "Logout",
                        changePassword: "Change password",
                        selectOwnVehicle: "Select/Change Vehicle"
                    },
                    directionType: {
                        ARRIVAL: "Arrival",
                        DEPARTURE: "Departure"
                    },
                    cargoType: {
                        NORMATIVE_TRAILER: "Trailer",
                        NORMATIVE_CONTAINER: "Container",
                        NORMATIVE_GENERAL_CARGO: "Cargo other than trailer and container",
                        DANGEROUS_TRAILER: "Trailer with dangerous goods",
                        DANGEROUS_CONTAINER: "Container with dangerous goods",
                        DANGEROUS_GENERAL_CARGO: "Dangerous goods other than trailer and container",
                        OVERSIZE: "Oversize",
                        LORRY: "Lorry, lorry with trailer or truck",
                        OVERSIZE_LORRY: "Lorry, lorry-trailer or oversized truck",
                        DANGEROUS_LORRY: "Lorry, lorry with trailer or truck with dangerous goods",
                        OVERSIZE_TRAILER: "Oversized trailer"
                    },
                    orderStatus: {
                        REGISTERED: "Registration",
                        CANCELED: "Canceled",
                        PARKING_ENTERED: "Parking entry",
                        PARKING_EXITED: "Parking exit",
                        CONFIRMED_BY_MANIFEST: "Manifest",
                        CANCELED_BY_MANIFEST: "Canceled by manifest",
                        DEPO_ENTERED: "Depo entry",
                        DEPO_EXITED: "Depo exit",
                        FERRY_ENTERED: "Ferry entry",
                        FERRY_EXITED: "Ferry exit"
                    },
                    relationType: {
                        TICKET_EXPORT: "Ticket",
                        ROAD_DEPO_FERRY: "Road-DEPO-Ferry",
                        FERRY_DEPO_ROAD: "Ferry-DEPO-Road",
                        RAIL_DEPO_FERRY: "Rail-DEPO-Ferry",
                        FERRY_DEPO_RAIL: "Ferry-DEPO-Rail",
                        RAIL_FERRY: "Rail-Ferry",
                        FERRY_RAIL: "Ferry-Rail",
                        ROAD_DEPO_ROAD: "Road-DEPO-Road",
                        ROAD_DEPO_RAIL: "Road-DEPO-Rail",
                        RAIL_DEPO_ROAD: "Rail-DEPO-Road",
                        RAIL_DEPO_RAIL: "Rail-DEPO-Rail",
                        FERRY_DEPO: "Ferry-DEPO",
                        RAIL_DEPO: "Rail-DEPO",
                        ROAD_DEPO: "Road-DEPO",
                        DEFAULT: "All"
                    },
                    searchButton: "Search",
                    paymentMethod: {
                        CASH: "cash",
                        BANK_TRANSFER: "bank transfer"
                    },
                    activeStatus: {
                        ACTIVE: "Active",
                        INACTIVE: "Inactive"
                    },
                    actionType: {
                        arrival: "import",
                        stop: "stop",
                        departure: "export"
                    },
                    locationDropdownLabel: "Please select a location",
                    allowPopup: {
                        headerEntry: "Allow entry",
                        headerExit: "Allow exit",
                        headerWithOrder: "Allow transit",
                        contentEntry: "Are you sure you want to allow ",
                        contentEntryWithoutOrder: "entry to the location: ",
                        contentEntryWithOrder: " the passage of the {{orderText}} with number ",
                        order: "order",
                        ticket: "ticket",
                        contentExit: "Are you sure you want to allow exit from the location: ",
                        actionText: "Allow",
                        errors: {
                            allowEntryErrorSuffix: "allowing entry to the location: {{locationName}}",
                            allowEntryWithOrderErrorSuffix: "permission to travel {{orderType}} number: {{orderId}}",
                            allowExitErrorSuffix: "permission to leave the location: {{locationName}}",
                            ticketError: "ticket",
                            orderError: "order"
                        }
                    },
                    notAllowPopup: {
                        headerEntry: "Don't allow entry",
                        headerExit: "Don't allow exit",
                        headerWithOrder: "Don't allow transit",
                        contentEntry: "Are you sure you don't want to allow ",
                        contentEntryWithoutOrder: "entry to the location: ",
                        contentEntryWithOrder: " the passage of the {{orderText}} with number ",
                        order: "order",
                        ticket: "ticket",
                        contentExit: "Are you sure you don't want to leave the location: ",
                        actionText: "Don't allow",
                        errors: {
                            notAllowEntryErrorSuffix: "not allowing entry to the location: {{locationName}}",
                            notAllowEntryWithOrderErrorSuffix: "not allowing the passage of {{orderType}} number: {{orderId}}",
                            notAllowExitErrorSuffix: "not allowing you to leave the location: {{locationName}}",
                            ticketError: "ticket",
                            orderError: "order"
                        }
                    },
                    ownedVehiclePopup: {
                        header: "Select a vehicle",
                        actionText: "Select",
                        otherBtn: "Without a vehicle",
                        dataLoadingError: "collecting own vehicles",
                        vehicleActions: "performing an action ",
                        withVehicle: "assigning a vehicle to a user",
                        withoutVehicle: "skipping the vehicle selection",
                        emptyMessage: "There are no own vehicles to choose from",
                        noSelectErrorMessage: "Select a vehicle from the list or skip using the `Without Vehicle` button"
                    },
                    dictionaries: {
                        title: "Dictionaries",
                        retrievalErrorSuffix: "dictionary retrieval",
                        itemRetrievalErrorSuffix: "dictionary data retrieval",
                        removeAction: {
                            header: "Are you sure you want to remove this item?",
                            secondHeader: "Remove item",
                            actionText: "Yes, remove",
                            line1: "Are you sure you want to remove this item from the list?",
                            line2: "This action cannot be reverted!"
                        },
                        ferries: {
                            title: "Ferries",
                            actions: {
                                addFerry: {
                                    button: "Add ferry +",
                                    header: "Add ferry"
                                },
                                modifyFerry: {
                                    header: "Modify ferry"
                                },

                            },
                            headers: {
                                number: "Ferry IMO No",
                                name: "Ferry name",
                                flagStateName: "Flag state",
                                shipownerName: "Shipowner"
                            },
                            errors: {
                                removeErrorSuffix: "ferry removal",
                                addErrorSuffix: "adding new ferry",
                                modifyErrorSuffix: "modifying ferry",
                                ferryNoLengthIsCorrect: "The IMO number cannot be longer than {{number}} characters"
                            },
                            httpErrors: {
                                object: "ferry",
                                number: "number",
                                name: "name",
                                numberForEmpty: "ferry IMO No",
                                nameForEmpty: "ferry name",
                                flagStateNameForEmpty: "flag state",
                                shipownerForEmpty: "shipowner"
                            }
                        },
                        ports: {
                            title: "Ports",
                            actions: {
                                addPort: {
                                    button: "Add port +",
                                    header: "Add port"
                                },
                                modifyPort: {
                                    header: "Modify port"
                                }
                            },
                            headers: {
                                name: "Port name",
                                imoCode: "IMO code",
                                country: "Country"
                            },
                            errors: {
                                removeErrorSuffix: "port removal",
                                addErrorSuffix: "adding new port",
                                modifyErrorSuffix: "modifying port",
                                portImoCodeLengthIsCorrect: "The IMO number cannot exceed {{number} characters"
                            },
                            httpErrors: {
                                object: "port",
                                nameForEmpty: "port name",
                                imoCodeForEmpty: "IMO code",
                                countryForEmpty: "country",
                                name: "port name",
                                imoCode: "IMO code",
                                country: "country"
                            }
                        },
                        companies: {
                            title: "Companies",
                            bankTransferLabel: "Settlement by bank transfer",
                            headers: {
                                name: "Company name",
                                taxNo: "Tax number",
                                phoneNo: "Phone number",
                                street: "Address",
                                city: "City",
                                postalCode: "Postal code",
                                countryName: "Country"
                            },
                            actions: {
                                addCompany: {
                                    button: "Add company +",
                                    header: "Add company"
                                },
                                modifyCompany: {
                                    header: "Modify company"
                                },
                                addNextDetail: "Add next +",
                                removeDetail: {
                                    header: "Are you sure you want to remove this item?",
                                    secondHeader: "Remove item",
                                    actionText: "Yes, remove",
                                    line1: "Are you sure you want to remove this item from the list?",
                                    line2: "This action cannot be reverted!"
                                }
                            },
                            errors: {
                                addErrorSuffix: "adding new company",
                                removeErrorSuffix: "company removal",
                                modifyErrorSuffix: "modifying company"
                            },
                            httpErrors: {
                                object: "company",
                                taxNo: "tax number",
                                name: "name",
                                nameForEmpty: "company name",
                                taxNoForEmpty: "tax number",
                                phoneNoForEmpty: "phone number",
                                streetForEmpty: "address",
                                cityForEmpty: "city",
                                postalCodeForEmpty: "postal code",
                                countryNameForEmpty: "country"
                            }
                        },
                        shipowners: {
                            title: "Shipowners",
                            actions: {
                                addShipowner: {
                                    button: "Add shipowner +",
                                    header: "Add shipowner"
                                },
                                modifyShipowner: {
                                    header: "Modify shipowner"
                                }
                            },
                            headers: {
                                name: "Shipowner name",
                                taxNo: "Tax number",
                                phoneNo: "Phone number",
                                street: "Address",
                                city: "City",
                                postalCode: "Postal code",
                                countryName: "Country",
                                imoCode: "IMO code"
                            },
                            errors: {
                                removeErrorSuffix: "shipowner removal",
                                addErrorSuffix: "adding new shipowner",
                                modifyErrorSuffix: "modifing shipowner",
                                removeErrorWhenShipownerHasFerry: "shipowner has an assigned ferry"
                            },
                            httpErrors: {
                                object: "shipowner",
                                name: "name",
                                taxNo: "tax number",
                                nameForEmpty: "shipowner name",
                                taxNoForEmpty: "tax number",
                                phoneNoForEmpty: "phone number",
                                streetForEmpty: "address",
                                cityForEmpty: "city",
                                postalCodeForEmpty: "postal code",
                                countryNameForEmpty: "country",
                                imoCodeForEmpty: "IMO code"
                            }
                        },
                        unCodes: {
                            title: "UN Codes",
                            headers: {
                                status: "Status",
                                code: "UN code",
                                name: "Name",
                                imdgClass: "IMDG class"
                            },
                            actions: {
                                modifyUnCode: {
                                    header: "Modify UN code"
                                },
                                addUnCode: {
                                    header: "Add Un code",
                                    button: "Add UN code +"
                                }
                            },
                            errors: {
                                removeErrorSuffix: "UN code removal",
                                addErrorSuffix: "adding new UN code",
                                modifyErrorSuffix: "modifying UN code"
                            },
                            httpErrors: {
                                object: "UN code",
                                code: "UN code",
                                name: "name",
                                statusForEmpty: "status",
                                codeForEmpty: "UN code",
                                nameForEmpty: "name",
                                imdgClassForEmpty: "IMDG class"
                            }
                        },
                        ownedVehicles: {
                            title: "Owned Vehicles",
                            actions: {
                                addOwnedVehicle: {
                                    button: "Add vehicle +",
                                    header: "Add vehicle"
                                },
                                modifyOwnedVehicle: {
                                    header: "Modify vehicle"
                                }
                            },
                            headers: {
                                name: "Name",
                                licencePlate: "Licence plate"
                            },
                            errors: {
                                removeErrorSuffix: "owned vehicle removal",
                                addErrorSuffix: "adding new owned vehicle",
                                modifyErrorSuffix: "modifying owned vehicle"
                            },
                            httpErrors: {
                                object: "vehicle",
                                nameForEmpty: "name",
                                licencePlateForEmpty: "licence plate",
                                name: "name",
                                licencePlate: "licence plate"
                            }
                        },
                        packing: {
                            title: "Packing",
                            actions: {
                                adding: {
                                    button: "Add packing +",
                                    header: "Add packing"
                                },
                                modifyPacking: {
                                    header: "Edit packing"
                                }
                            },
                            headers: {
                                name: "Name"
                            },
                            errors: {
                                removeErrorSuffix: "packing removal",
                                addErrorSuffix: "adding new packing",
                                modifyErrorSuffix: "modifying packing"

                            },
                            httpErrors: {
                                object: "packing",
                                nameForEmpty: "name",
                                name: "name"
                            }
                        }
                    },
                    timetable: {
                        title: "Timetable",
                        retrievalErrorSuffix: "timetable retrieval",
                        wharf: "Wharf",
                        periodDateLabel: "Presented period",
                        outsideTPS: "Outside TPŚ",
                        copyDataPopup: {
                            dataLabel: "Selected date range",
                            header: "Copy timetable",
                            actionText: "Submit",
                            errorMessage: "the selected week to be copied",
                            copyWeekErrorMessage: "The week you want to copy cannot be earlier than the selected week to be copied to.",
                            copyFromLabel: "From: ",
                            toCopyLabel: "To: ",
                            errorSelectedWeekMessage: "select the week"
                        },
                        actions: {
                            addAction: {
                                button: "Add new +",
                                header: "Add new"
                            },
                            modifyAction: {
                                button: "Modify",
                                header: "Modify"
                            },
                            detailsAction: {
                                button: "Details",
                                header: "Details: ",
                                cancelText: "Close"
                            },
                            errors: {
                                errorMessage: "data download"
                            },
                            download: {
                                button: "Download timetable",
                                header: "Select file format",
                                actionText: "Download",
                                from: "From",
                                to: "To"
                            },
                            names: {
                                arrival: "Import (Arrival-unloading)",
                                stop: "Stop",
                                departure: "Export (Departure-loading)"
                            },
                            copyDataBtn: "Copy timetable",
                            addNextAction: "Add next +",
                            removeAction: {
                                header: "Are you sure you want to remove this {{value}}?",
                                position: "item",
                                action: "action",
                                secondHeader: "Remove {{value}}",
                                actionText: "Yes, remove",
                                line1: "Are you sure you want to remove this {{value}}?",
                                line2: "This operation cannot be reverted!",
                                errorMessagePart1: "action deletion",
                                errorMessagePart2: "a ticket or an order has already been registered for the action"
                            },
                            cancelAction: {
                                header: "Are you sure you want to cancel the action?",
                                secondHeader: "Cancel the action",
                                actionText: "Yes, cancel",
                                line1: "Are you sure you want to cancel the action?",
                                line2: "This operation cannot be undone!",
                                errorMessage: "cancellation of shares"
                            }
                        },
                        headers: {
                            ferry: "Ferry",
                            actionType: "Action",
                            voyageNo: "Voyage No",
                            wharf: "Wharf",
                            notes: "Notes",
                            time: "Time",
                            plannedTime: "Planned time",
                            actualTime: "Actual time",
                            arrivalTime: "Planned arrival time",
                            departureTime: "Planned departure time",
                            actualArrivalTime: "Actual arrival time",
                            actualDepartureTime: "Actual departure time",
                            routeAndLoading: "Route and loading",
                            route: "Route",
                            startLoadingTime: "Start loading time",
                            endLoadingTime: "End loading time",
                            openParkingTime: "Open parking time",
                            destinationPort: "Destination port",
                            filters: {
                                year: "Year",
                                week: "Week",
                                prevBtn: "Previous week",
                                nextBtn: "Next week"
                            }
                        },
                        errors: {
                            addErrorSuffix: "adding timetable action",
                            editErrorSuffix: "editing timetable action",
                            downloadErrorSuffix: "downloading timetable",
                            voyageNoLength: "Voyage number can be up to 15 characters long"
                        }
                    },
                    administration: {
                        title: "Administration",
                        itemRetrievalErrorSuffix: "users list retrieval",
                        headers: {
                            enabled: "Status",
                            userName: "User name",
                            role: "Role in the team",
                            language: "Preferred language"
                        },
                        status: {
                            enabled: "Enabled",
                            disabled: "Disabled"
                        },
                        roles: {
                            administrator: "Administrator",
                            supervisor: "Supervisor",
                            observer: "Observer",
                            depo: "Depo",
                            helpdesk: "Helpdesk"
                        },
                        languages: {
                            pl: "Polish",
                            en: "English"
                        },
                        actions: {
                            resetPassword: "Password reset",
                            disable: "Disable",
                            enable: "Enable",
                            addUser: "New user +",
                            changePassword: "Change password"
                        },
                        errors: {
                            disableErrorSuffix: "user disable",
                            enableErrorSuffix: "user enable",
                            resetPasswordErrorSuffix: "user password reset",
                            changePasswordErrorSuffix: "manually changing the user's password",
                            idNotFound: "user with id {{id}} not exist",
                            invalidPassword: "Invalid password. New password must be at least 8 characters long, contain at least one uppercase letter, contain at least one lowercase letter, contain at least one number and must be different from the previous password."
                        },
                        disableAction: {
                            header: "Are you sure you want to disable user?",
                            secondHeader: "Disable user",
                            actionText: "Yes, disable",
                            firstPart: "Are you sure you want to disable user ",
                            lastPart: "? This action can be reverted."
                        },
                        enableAction: {
                            header: "Enable user?",
                            secondHeader: "Enable user",
                            actionText: "Yes, enable",
                            firstPart: "You want to enable user ",
                            lastPart: "? This action can be reverted."
                        },
                        resetPasswordAction: {
                            header: "Reset a user's password?",
                            secondHeader: "Password reset",
                            actionText: "Yes, reset",
                            firstPart: "You want to reset the password of a user named ",
                            lastPart: "? This action cannot be reverted!"
                        },
                        removeAction: {
                            header: "Are you want to delete the user?",
                            secondHeader: "Remove user",
                            actionText: "Yes, remove",
                            firstPart: "You want to remove a user named ",
                            lastPart: "? This action cannot be reverted!",
                            errorMessage: " remove a user"
                        },
                        changeUserPasswordAction: {
                            header: "Manually changing the user's password",
                            actionText: "Change password"
                        },
                        addUser: {
                            header: "Add new user",
                            usernameAndPasswordSection: {
                                header: "Username and password",
                                username: "Username",
                                language: "Language",
                                password: "Password",
                                confirmPassword: "Confirm password"
                            },
                            permissionsSection: {
                                header: "Permissions",
                                role: "Role",
                                additionalRole: "Additional role",
                                resetPasswordInfo: "(password reset)"
                            },
                            errors: {
                                addUserErrorSuffix: "adding new user",
                                incorrectPassword: "Password must be at least 8 characters long, contain at least one uppercase letter, contain at least one lowercase letter, contain at least one number.",
                                incorrectConfirmPassword: "The passwords entered must be the same"
                            },
                            add: "Create"
                        },
                        modifyUser: {
                            header: "Modify user",
                            resetPassword: "Password reset",
                            changePassword: "Change password",
                            errors: {
                                modifyUserErrorSuffix: "modify user",
                                itemRetrievalErrorSuffix: "user data retrieval",
                            }
                        }
                    },
                    user: {
                        changePassword: {
                            header: "Change password",
                            userAndPasswordHeader: "Username and password",
                            currentPassword: "Previous password",
                            newPassword: "New password",
                            confirmPassword: "Confirm password",
                            username: "Username",
                            errors: {
                                changePasswordErrorSuffix: "change password",
                                incorrectPassword: "Password must be at least 8 characters long, contain at least one uppercase letter, contain at least one lowercase letter, contain at least one number.",
                                incorrectConfirmPassword: "The passwords entered must be the same",
                                incorrectNewPassword: "The new password must be different from the current password",
                                invalidPassword: "invalid current password",
                                userNotFound: "user {{username}} not found"
                            },
                            successFirstPart: "Success! ",
                            successSecondPart: "Password has been changed."
                        }
                    },
                    transportation: {
                        notificationTile: "Notifications",
                        emptyNotificationMessage: "No notifications for {{orderType}}",
                        tcrTile: "Trailer condition (TCR)",
                        retrievalErrorSuffixForNotification: "notifications retrieval",
                        orderType: {
                            ticket: "the ticket",
                            order: "the order"
                        },
                        errorMessage: {
                            noLengthValidator: "The {{object}} number cannot be longer than {{number}} characters",
                            trailerRegNo: "trailer",
                            lorryRegNo: "lorry",
                            containerNo: "container",
                            wagonRegNo: "wagon",
                            voyageNo: "voyage",
                            bookingNo: "booking",
                            cargoDesc: "The cargo desc cannot be longer ",
                            remarks: "Notes cannot be longer ",
                            lengthValidator: "{{firstPart}} than {{number}} characters",
                            recipientLengthValidator: "The recipient's name cannot be longer than {{number}} characters"
                        },
                        filters: {
                            dateOfRegistrationFrom: "Date of registration: From",
                            dateOfRegistrationTo: "Date of registration: To",
                            arrivalDepartureTime: "Date of arrival/departure",
                            relationType: "Relation type",
                            ferry: "Ferry",
                            orderStatus: "Status",
                            trailerNo: "Trailer Number",
                            regNo: "Vehicle Number"
                        },
                        ticket: {
                            title: "Tickets",
                            retrievalErrorSuffix: "tickets list retrieval",
                            headers: {
                                status: "Status",
                                arrivalDepartureTime: "Departure Time",
                                createdAt: "Creation Time",
                                relationType: "Relation",
                                regNo: "Vehicle number",
                                shipownerName: "Shipowner",
                                ferry: "Ferry",
                                gateNo: "Gate No",
                                info: "Info",
                                cargoType: "Cargo type"
                            },
                            actions: {
                                modifyStatus: "Change status",
                                addNextDangerousGood: "Add next +",
                                scanTicket: "Scan ticket"
                            },
                            addTicket: {
                                header: "Add a new ticket",
                                button: "Register a ticket +",
                                saveButtonText: "Register"
                            },
                            modifyTicket: {
                                header: "Edit ticket",
                                button: "Edit",
                                errors: {
                                    retrievalErrorSuffix: "ticket retrieval",
                                    modifyErrorSuffix: "ticket editing",
                                }
                            },
                            details: {
                                general: {
                                    header: "Basic information",
                                    properties: {
                                        status: "Status",
                                        cargoType: "Cargo type",
                                        currentRoute: "Current route",
                                        gateNo: "Gate no",
                                        barcodeNo: "Barcode number",
                                        createdAt: "Creation date"
                                    }
                                },
                                transportation: {
                                    header: "Transportation",
                                    properties: {
                                        trailerRegNo: "Trailer registration number",
                                        transportCompany: "Transport company",
                                        lorryRegNo: "Lorry registration number"
                                    }
                                },
                                voyage: {
                                    header: "Voyage",
                                    properties: {
                                        shipownerName: "Shipowner name",
                                        voyageNo: "Voyage number",
                                        arrivalDepartureTime: "Arrival/departure date",
                                        ferryName: "Ferry name",
                                        originDestinationPort: "Origin/destination port",
                                        originDestinationCountry: "Origin/destination country",
                                        bookingNo: "Booking number"
                                    }
                                },
                                cargo: {
                                    header: "Cargo",
                                    properties: {
                                        cargoDesc: "Cargo name",
                                        weight: "Weight",
                                        width: "Width",
                                        length: "Length",
                                        height: "Height",
                                        securingDeclaration: "Securing declaration"
                                    }
                                },
                                dangerousGoods: {
                                    header: "Dangerous goods",
                                    properties: {
                                        unCode: "UN code",
                                        packing: "Packing",
                                        packingQuantity: "Number of packages",
                                        packingGroup: "Packing category",
                                        weight: "Weight"
                                    },
                                    thereMustBeAtLeastOne: "For this type of cargo, at least one dangerous good must be selected."
                                }
                            },
                            preview: {
                                header: "Ticket no: {{number}}",
                                actions: {
                                    goBack: "Go back to tickets list",
                                    details: "Ticket details",
                                    alerts: "Alerts"
                                }
                            },
                            errors: {
                                addErrorSuffix: "registering a new ticket",
                                modifyErrorSuffix: "ticket modification",
                                correctDateWithTime: "Invalid date with time",
                                detailsRetrievalErrorSuffix: "ticket data retrieval"
                            },
                            httpErrors: {
                                object: "ticket",
                                status: "status",
                                cargoType: "type of cargo",
                                gateNo: "gate number",
                                currentRoute: "the current route",
                                trailerRegNo: "trailer number",
                                transportCompany: "transport company",
                                lorryRegNo: "tractor number",
                                shipownerName: "the shipowner",
                                voyageNo: "travel number",
                                arrivalDepartureTime: "time of arrival/departure",
                                ferryName: "the name of the ferry",
                                originDestinationPort: "the port of destination",
                                originDestinationCountry: "destination country",
                                cargoDesc: "the name of the cargo",
                                weight: "the weight of the load",
                                length: "length",
                                width: "width",
                                securingDeclaration: "securing declaration",
                                unCode: "UN code",
                                packing: "packing",
                                packingQuantity: "the number of packages",
                                packingGroup: "packing categories",
                                dangerousGoodsWeight: "the weight of the dangerous goods",
                                cargoTypeEmpty: "type of cargo",
                                gateNoEmpty: "gateway number",
                                currentRouteEmpty: "current route",
                                trailerRegNoEmpty: "trailer number",
                                shipownerNameEmpty: "shipowner",
                                voyageNoEmpty: "trip number",
                                arrivalDepartureTimeEmpty: "time of arrival/departure",
                                ferryNameEmpty: "the name of the ferry",
                                originDestinationPortEmpty: "port of destination",
                                originDestinationCountryEmpty: "destination country",
                                weightEmpty: "weight of the load",
                                lengthEmpty: "length",
                                widthEmpty: "width",
                                unCodeEmpty: "UN code"
                            },
                            scanBarcodePopup: {
                                header: "Ticket scanner",
                                content: "Scan the barcode",
                                label: "Barcode",
                                actionText: "Confirm",
                                successMessage: "The vehicle was allowed into the port area",
                                errorMessage: " ticket scanning",
                                invalidOrderStatus: "Invalid ticket status. The ticket is in the status: {{value}}",
                                barcodeNoNotFound: "No ticket with this barcode found."
                            }
                        },
                        order: {
                            title: "Orders",
                            retrievalErrorSuffix: "downloading the records of orders",
                            headers: {
                                status: "Status",
                                arrivalDepartureTime: "Arrival/Departure time",
                                relationType: "Relation",
                                regNo: "Vehicle number",
                                trailerNo: "Trailer number",
                                shipownerName: "Shipowner",
                                ferry: "Ferry",
                                info: "Info"
                            },
                            actions: {
                                tcr: "TCR",
                                tcrLong: "Trailer condition (TCR)",
                                addOrder: "Add a new order +",
                                modifyOrder: "Modify",
                                cancelOrder: "Cancel",
                                allow: "Allow",
                                notAllow: "Not allow",
                                modifyStatus: "Change status"
                            },
                            preview: {
                                header: "Order no: {{number}}",
                                actions: {
                                    goBack: "Go back to orders list",
                                    details: "Order details",
                                    status: "Status",
                                    photos: "Photos"
                                },
                                retrievalErrorSuffix: "order data retrieval",
                            },
                            warningPopup: {
                                header: "Warning",
                                content1: "Long period of time has been selected, it may cause a decrease in system performance.",
                                content2: "Are you sure you want to execute this request?",
                                actionText: "Yes"
                            },
                            details: {
                                general: {
                                    header: "General data",
                                    properties: {
                                        status: "Status",
                                        relationType: "Relation",
                                        cargoType: "Cargo type",
                                        pinCode: "PIN",
                                        barcodeNo: "Barcode no",
                                        currentRoute: "Current route",
                                        gateNo: "Gate number",
                                        createdAt: "Creation date"
                                    }
                                },
                                temperature: {
                                    header: "Temperature",
                                    properties: {
                                        requestedTemp1: "Requested temperature 1",
                                        requestedTemp2: "Requested temperature 2"
                                    }
                                },
                                transportation: {
                                    header: "Transportation",
                                    properties: {
                                        trailerRegNo: "Trailer registration number",
                                        transportCompany: "Transport company",
                                        recipient: "Recipient",
                                        supplierLorryRegNo: "Supplier's lorry nubmer",
                                        recipientLorryRegNo: "Recipient's lorry number",
                                        lorryRegNo: "Lorry registration number",
                                        provider: "Provider"
                                    }
                                },
                                voyage: {
                                    header: "Voyage",
                                    properties: {
                                        shipownerName: "Shipowner name",
                                        voyageNo: "Voyage number",
                                        arrivalDepartureTime: "Arrival/departure date",
                                        ferryName: "Ferry name",
                                        originDestinationPort: "Origin/destination port",
                                        originDestinationCountry: "Origin/destination country",
                                        bookingNo: "Booking number"
                                    }
                                },
                                cargo: {
                                    header: "Cargo",
                                    properties: {
                                        cargoDesc: "Cargo name",
                                        weight: "Weight",
                                        length: "Length",
                                        height: "Height",
                                        width: "Width",
                                        packingQuantity: "Number of packages",
                                        cbm: "CBM",
                                        packing: "Package",
                                        remarks: "Remarks",
                                        wagonRegNo: "Wagon no",
                                        supplierWagonRegNo: "Supplier's wagon number",
                                        recipientWagonRegNo: "Receiver's wagon number",
                                        securingDeclaration: "Securing declaration"
                                    }
                                },
                                container: {
                                    header: "Container",
                                    properties: {
                                        containerNo: "Container no",
                                        containerSize: "Container size",
                                        vgm: "VGM"
                                    }
                                },
                                costs: {
                                    header: "Costs",
                                    properties: {
                                        storageTime: "Storage time",
                                        chargeableTime: "Chargeable time",
                                        paymentMethod: "Payment method",
                                        paymentWaiver: "Payment waiver",
                                        paymentDocumentNumber: "Payment document number",
                                        parkingCost: "Parking cost"
                                    }
                                },
                                dangerousGoods: {
                                    header: "Dangerous goods",
                                    properties: {
                                        unCode: "UN code",
                                        packing: "Packing",
                                        packingQuantity: "Number of packages",
                                        packingGroup: "Packing category",
                                        weight: "Weight"
                                    }
                                },
                                files: {
                                    exportOrderCargoFileName: "Export order CARGO-{{number}}",
                                    importOrderCargoFileName: "Import order CARGO-{{number}}",
                                    transportType: {
                                        road: "road",
                                        rail: "rail"
                                    },
                                    importTrailerOrContainerOrderFileName: "Import order TRAILER/CONTAINER-{{number}}",
                                    exportTrailerOrContainerOrderFileName: "Export order TRAILER/CONTAINER-{{number}}",
                                    noSeaTrafficTrailerOrContainerFileName: "DEPO order {{number}}",
                                    fileDownloadErrorSuffix: "file generation",
                                    cancelOrderErrorSuffix: "order cancellation"
                                },
                                assignWagonsNumberPopup: {
                                    header: "Assign a wagon number",
                                    contentPart1: "Enter the number of the selected wagon",
                                    contentPart2: "Remember, before you save, check the correctness of the entered data.",
                                    assignWagonsNumberErrorSuffix: "assigning a wagon number"
                                }
                            },
                            tcr: {
                                header: "Order no: {{number}}",
                                equipmentType: {
                                    TARPAULIN: "Tarpaulin",
                                    SIDE_BOARD: "Side board",
                                    LEG: "Leg",
                                    WHEEL: "Wheel",
                                    LIGHT: "Light",
                                    SPARE_WHEEL: "Spare wheel",
                                    WINCH: "Winch",
                                    PLUMB: "Plumb",
                                    WEDGE: "Wedge",
                                    AGGREGATE: "Aggregate",
                                    BICYCLE_PROTECTION: "Bicycle protection"
                                },
                                sections: {
                                    trailerCondition: {
                                        header: "Trailer condition (TCR)",
                                        damageHeaders: {
                                            sideType: "Side",
                                            damageUpdateTime: "Last modification",
                                            equipmentType: "Damage place",
                                            damageType: "Damage",
                                            direction: ""
                                        },
                                        actions: {
                                            manage: "Manage",
                                        },
                                        sideType: {
                                            FRONT: "Front",
                                            REAR: "Rear",
                                            LEFT: "Left side",
                                            RIGHT: "Right side"
                                        },
                                        sideTypeFirstLetter: {
                                            FRONT: "F",
                                            REAR: "R",
                                            LEFT: "LS",
                                            RIGHT: "RS"
                                        },
                                        damageType: {
                                            SCRATCHED: "Scratched",
                                            BENT: "Bent",
                                            TORN: "Torn",
                                            LEAKAGE: "Leakage",
                                            CRACKED: "Cracked",
                                            BROKEN: "Broken",
                                            DENT: "Dent",
                                            MISSING: "Missing",
                                            OUT_OF_ORDER: "Out of order"
                                        },
                                        damageLocation: {
                                            LEFT_TOP: "left top",
                                            RIGHT_TOP: "right top",
                                            LEFT_BOTTOM: "left bottom",
                                            RIGHT_BOTTOM: "right bottom",
                                            FRONT: "front",
                                            CENTER: "center",
                                            REAR: "rear"
                                        },
                                        modifyTrailerDamages: {
                                            header: "Damage list",
                                            saveButtonText: "OK",
                                            returnButtonText: "Return",
                                            headers: {
                                                direction: "State",
                                                damageUpdateTime: "Date",
                                                code: "Code",
                                                equipmentType: "Damage place",
                                                damageType: "Damage type"
                                            }
                                        }
                                    },
                                    additionalEquipment: {
                                        header: "Additional equipment",
                                        quantity: "quantity"
                                    },
                                    temperature: {
                                        header: "Temperature",
                                        labels: {
                                            actualTemp1: "Measured 1",
                                            actualTemp2: "Measured 2",
                                            requestedTemp1: "The requested 1",
                                            requestedTemp2: "The requested 2"
                                        }
                                    }
                                },
                                retrievalErrorSuffix: "TCR retrieval",
                                modifyErrorSuffix: "modifying TCR",
                                file: {
                                    button: "Download the TCR report",
                                    fileName: "Trailer Condition report {{number}}"
                                },
                                successFirstPart: "Success! ",
                                successSecondPart: "TCR has been saved"
                            },
                            status: {
                                actualChipLabel: "Current",
                                nextChipLabel: "Next",
                                currentRouteLabel: "Current route",
                                retrievalErrorSuffix: "status retrieval",
                                noStatus: "Not applicable",
                                actions: {
                                    discard: "Discard",
                                    allow: "Allow",
                                    allowWithTcr: "Allow with TCR"
                                },
                                discardPopup: {
                                    header: "Are you sure you want to discard?",
                                    secondHeader: "Don't allow entry",
                                    content: "Are you sure you want to decline the transport and have it departed from the terminal?",
                                    actionText: "Yes, discard",
                                    discardErrorSuffix: "rejection of transport"
                                },
                                allowWithTcrRequiredPopup: {
                                    header: "Complete the TCR",
                                    contentPart1: "Go to TCR to complete the document or ",
                                    contentSkip: "Skip",
                                    contentPart2: " if the shipment is to be accepted without filling ",
                                    contentTcrBold: "TCR.",
                                    actionText: "Skip",
                                    cancelText: "Go to TCR",
                                    allowWithTcrRequiredErrorSuffix: "confirming the TCR"
                                },
                                allowWithLocationDepoPopup: {
                                    header: "Allow entry",
                                    content: "Are you sure you want to allow entry number of order: ",
                                    label: "Please select a location",
                                    actionText: "Allow"
                                },
                                supervisorFlowActionsPopup: {
                                    header: "Change status",
                                    actionText: "Change",
                                    content: "Are you sure you want to change status: ",
                                    availableStatusesErrorSuffix: "downloading available statuses",
                                    label: "Pick action",
                                    executeChangeStatusErrorSuffix: "changing status",
                                    actions: {
                                        GET_BACK_TO_REGISTRATION: "Revert to Registration",
                                        GET_BACK_TO_PORT_ENTRANCE: "Revert to Parking entrance",
                                        GET_BACK_TO_PORT_EXIT: "Revert to Parking exit",
                                        GET_BACK_TO_DEPO_ENTRANCE: "Revert to Depo entrance",
                                        GET_BACK_TO_DEPO_EXIT: "Revert to Depo exit",
                                        GET_BACK_TO_FERRY_ENTRANCE: "Revert to Ferry entrance",
                                        GET_BACK_TO_FERRY_EXIT: "Revert to Ferry exit",
                                        CANCEL: "Cancel",
                                        ENTER_PORT: "Enter parking",
                                        EXIT_PORT: "Exit parking",
                                        ENTER_DEPO: "Enter depo",
                                        EXIT_DEPO: "Exit depo",
                                        ENTER_FERRY: "Enter ferry",
                                        EXIT_FERRY: "Exit ferry",
                                        CONFIRM_BY_MANIFEST: "Manifest",
                                        CANCEL_BY_MANIFEST: "Cancel by manifest"
                                    }
                                },
                                allowErrorSuffix: "confirmation of transport",
                                locationsErrorSuffix: "locations retrieval",
                                forbiddenError: "Operation not allowed. Refresh the screen.",
                            },
                            addOrder: {
                                header: "Add a new order",
                                saveButtonText: "Register",
                                errors: {
                                    addErrorSuffix: "registering a new order",
                                    correctDateWithTime: "Invalid date with time",
                                    pinCodeErrorMessage: "The pin should consist of 5 non-negative digits",
                                    barcodeErrorMessage: "The barcode should be a maximum of 20 characters"
                                },
                                httpErrors: {
                                    object: "order",
                                    pinCode: "PIN code",
                                    barcodeNo: "barcode",
                                    voyageNo: "voyage number",
                                    bookingNo: "booking number"
                                }
                            },
                            modifyOrder: {
                                header: "Modify order",
                                errors: {
                                    retrievalErrorSuffix: "order retrieval",
                                    modifyErrorSuffix: "modifying order",
                                }
                            },
                            photos: {
                                header: "Order no: {{number}}",
                                subHeader: "Photos",
                                headers: {
                                    sideType: "Side",
                                    createdAt: "Time and date of execution",
                                    direction: ""
                                },
                                actions: {
                                    viewPhoto: "View photo",
                                },
                                sideType: {
                                    FRONT: "Front",
                                    REAR: "Rear",
                                    LEFT: "Left side",
                                    RIGHT: "Right side",
                                    TOP: "Top"
                                },
                                sideTypeFirstLetter: {
                                    FRONT: "F",
                                    REAR: "R",
                                    LEFT: "LS",
                                    RIGHT: "RS",
                                    TOP: "T"
                                },
                                imageAlt: "Photo {{sideType}}",
                                retrievalErrorSuffix: "photos retrieval",
                                imageNotFoundError: "Failed to load the photo. Please try again later."
                            }
                        }
                    },
                    topology: {
                        title: "Port topology",
                        locations: {
                            title: "Locations",
                            headers: {
                                apiKey: "API Key",
                                locationType: "Type",
                                url: "Url address",
                                name: "Location",
                                description: "Description"
                            },
                            actions: {
                                addLocation: {
                                    button: "Add location +",
                                    header: "Add new location"
                                },
                                modifyLocation: {
                                    button: "Modify",
                                    header: "Modify location"
                                },
                            },
                            locationType: {
                                ENTRY_TERMINAL: "Entry terminal",
                                EXIT_TERMINAL: "Exit terminal",
                                PHOTOSHOOTER: "Photoshooter",
                                LIGHTBOARD: "Lightboard",
                                PARKING: "Parking",
                                WHARF: "Wharf",
                                NO_AUTOMATION: "No automation"
                            },
                            errors: {
                                retrievalErrorSuffix: "locations retrieval",
                                addErrorSuffix: "adding new location",
                                invalidUrl: "Invalid url address",
                                apiKeyCorrectLength: "The API key must be at least 32 characters long",
                                modifyErrorSuffix: "modifying the location",
                                selectedLocationErrorSuffix: "the selected location retrieval",
                                removeErrorSuffix: "deleting a location"
                            },
                            httpErrors: {
                                object: "location",
                                apiKey: "API key",
                                locationType: "type",
                                url: "Url address",
                                name: "name",
                                apiKeyEmpty: "API key",
                                locationTypeEmpty: "type",
                                urlEmpty: "Url address",
                                nameEmpty: "name"
                            },
                            checkboxLabel: {
                                openParking: "Open parking",
                                startLoading: "Start loading"
                            },
                            removeAction: {
                                header: "Are you sure you want to delete the location?",
                                secondHeader: "Delete location",
                                actionText: "Yes, remove",
                                line1: "Are you sure you want to delete the location?",
                                line2: "This action cannot be reverted!"
                            }
                        },
                        routes: {
                            title: "Routes",
                            headers: {
                                name: "Route name",
                                isActive: "Status",
                                supportedRelationTypes: "Relation type",
                                supportedCargoTypes: "Cargo type",
                                wayPoints: "Location",
                                location: "Location",
                                basicRoute: "Basic route",
                                alternativeRoute: "Alternative route",
                                sign: "Basic route sign",
                                alternativeSign: "Alternative route sign"
                            },
                            actions: {
                                activeAction: "Active",
                                activePopup: {
                                    header: "Are you sure you want to activate the route?",
                                    secondHeader: "Activate the route",
                                    contentPart1: "Are you sure you want to activate the route named ",
                                    contentPart2: " ? This action can be reverted.",
                                    actionText: "Yes, activate",
                                    errorSuffix: "route activation"
                                },
                                inactiveAction: "Inactive",
                                inactivePopup: {
                                    header: "Are you sure you want to deactivate the route?",
                                    secondHeader: "Deactivate the route",
                                    contentPart1: "Are you sure you want to deactivate the route named ",
                                    contentPart2: " ? This action can be reverted.",
                                    actionText: "Yes, deactivate",
                                    errorSuffix: "route deactivation"
                                },
                                removeAction: "Remove",
                                removePopup: {
                                    header: "Are you sure you want to delete the route?",
                                    secondHeader: "Remove route",
                                    contentPart1: "Are you sure you want to delete the route named ",
                                    contentPart2: " ? This action cannot be reverted!",
                                    actionText: "Yes, remove",
                                    errorSuffix: "route deletion"
                                },
                                addRoute: {
                                    button: "Add a route +",
                                    header: "Add a new route"
                                },
                                modifyRoute: {
                                    button: "Modify",
                                    header: "Modify route"
                                }
                            },
                            errors: {
                                retrievalErrorSuffix: "routes retrieval",
                                oneOrMoreSelectedError: "At least one type must be selected",
                                addErrorSuffix: "adding new route",
                                modifyErrorSuffix: "modifying the route",
                                downloadDataErrorSuffix: "downloading data to the form",
                                selectedRouteErrorSuffix: "the selected route retrieval"
                            },
                            httpErrors: {
                                object: "route",
                                name: "name",
                                nameEmpty: "route name",
                                supportedRelationTypesEmpty: "relation type",
                                supportedCargoTypesEmpty: "cargo type",
                                locationIdEmpty: "location",
                                signEmpty: "basic route sign",
                                alternativeSignEmpty: "alternative route sign"
                            }
                        }
                    },
                    documents: {
                        title: "Documents",
                        retrievalErrorSuffix: "documents retrieval",
                        generalDeclaration: {
                            title: "General Declaration",
                            filters: {
                                arrivalDepartureTime: "Arrival/departure",
                                type: "Type",
                                shipowner: "Shipowner",
                                ferry: "Ferry"
                            },
                            headers: {
                                directionType: "Type",
                                shipownerName: "Shipowner",
                                ferryName: "Ferry",
                                ferryImoCode: "Ship IMO No",
                                voyageNo: "Voyage No",
                                arrivalDeparturePort: "Arrival/Departure Port",
                                arrivalDepartureTime: "Arrival/Departure Time",
                                originDestinationPort: "Origin/Destination Port"
                            },
                            preview: "Preview",
                            details: {
                                header: "No {{number}}",
                                retrievalErrorSuffix: "retrieving the details of the general declaration",
                                files: {
                                    failedGenerate: "Failed to generate the file",
                                    generalDeclaration: {
                                        button: "Print general declaration to file",
                                        fileName: "General declaration no {{number}}"
                                    },
                                    manifest: {
                                        button: "Print manifest to file",
                                        fileName: "Manifest for general declaration no {{number}}"
                                    }
                                },
                                general: {
                                    properties: {
                                        ferryName: "Ferry",
                                        ferryImoCode: "Ship IMO No",
                                        shipownerName: "Shipowner",
                                        shipownerImoCode: "Shipowner IMO No",
                                        voyageNo: "Voyage No",
                                        ssDraft: "Ship draft",
                                        totalWeight: "Total weight",
                                        arrivalDeparturePort: "Arrival/Departure Port",
                                        arrivalDepartureTime: "Date of entry",
                                        originDestinationPort: "Origin/Destination Port",
                                        wharfDesc: "Berth in port",
                                        passengersNumber: "Number of passengers",
                                        briefOfVoyage: "Brief of voyage",
                                        marineHealthDeclaration: "Marine health declaraton",
                                        remarks: "Remarks"
                                    }
                                },
                                manifests: {
                                    header: "Manifests",
                                    properties: {
                                        version: "Version",
                                        bookingNo: "Booking No",
                                        arrivalDepartureTime: "Arrival/Departure Time",
                                        loadingType: "Loading Type",
                                        cargoDesc: "Cargo Description",
                                        lorryRegNo: "Lorry No",
                                        trailerRegNo: "Trailer No",
                                        containerNo: "Container No"
                                    }
                                }
                            },
                            errors: {
                                manifestNotFound: "Manifest number {{number}} not found"
                            }
                        },
                        manifests: {
                            title: "Manifests",
                            filters: {
                                version: "Version",
                                type: "Type",
                                shipowner: "Shipowner",
                                voyageNo: "Voyage No"
                            },
                            headers: {
                                version: "Version",
                                directionType: "Type",
                                shipownerName: "Shipowner",
                                ferryName: "Ship name",
                                voyageNo: "Voyage No",
                                bookingNo: "Booking No",
                                arrivalDepartureTime: "Arrival/Departure Time",
                                loadingType: "Loading Type",
                                cargoDesc: "Cargo Description"
                            },
                            preview: "Preview",
                            details: {
                                header: "No {{number}}",
                                retrievalErrorSuffix: "manifest details retrieval",
                                properties: {
                                    ferryName: "Ferry",
                                    ferryImoCode: "Ferry IMO code",
                                    shipownerImoCode: "Shipowner IMO code",
                                    voyageNo: "Voyage No",
                                    arrivalDepartureTime: "Arrival/Departure Time",
                                    bookingNo: "Booking No",
                                    loadingType: "Loading type",
                                    lorryRegNo: "Lorry registration no",
                                    trailerRegNo: "Trailer registration no",
                                    length: "Cargo length",
                                    cargoDesc: "Cargo name",
                                    weight: "Cargo weight",
                                    plugin: "Plugin",
                                    imdgClass: "IMDG class",
                                    payableBy: "Payable by",
                                    shipperName: "Road freight forwarder",
                                    originCountry: "Origin country",
                                    destinationCountry: "Destination country",
                                    overwide: "Cargo overwide",
                                    freight: "Freight",
                                    currency: "Currency",
                                    containerNo: "Container no",
                                    containerSize: "Container size",
                                    vgm: "VGM weight",
                                    billOfLading: "Bill of lading"
                                }
                            }
                        }
                    },
                    alerts: {
                        title: "Alerts",
                        retrievalErrorSuffix: "alerts retrieval",
                        readErrorSuffix: "marking the alert {{id}} as read",
                        resolveErrorSuffix: "marking the alert {{id}} as resolved",
                        status: {
                            not: "not ",
                            isRead: "read",
                            isResolved: "resolved"
                        },
                        actions: {
                            read: "Read this",
                            resolve: "Resolve alert"
                        },
                        property: {
                            date: "Date",
                            location: "Location",
                            orderNo: "Order no",
                            ticketNo: "Ticket no",
                            trailerRegNo: "Trailer",
                            lorryRegNo: "Lorry",
                            wagonNo: "Wagon",
                            bookingNo: "Booking No",
                            containerNo: "Container"
                        },
                        notifications: {
                            PHOTOS_NOT_TAKEN: "Photos were not taken",
                            VEHICLE_RECOGNIZED_AND_NOT_ASSIGNED_TO_ORDER: "Recognized vehicle, not assigned to ticket/order",
                            VEHICLE_NOT_RECOGNIZED: "Unrecognized vehicle",
                            TICKET_REGISTERED_NEAR_END_OF_LOADING_TIME: "Shipowner registered ticket {{time}} minutes before end of ferry loading",
                            ORDER_REGISTERED_NEAR_END_OF_LOADING_TIME: "Shipowner registered order {{time}} minutes before end of ferry loading",
                            VEHICLE_ENTERED_JUST_BEFORE_PARKING_CLOSE: "Vehicle entered port {{time}} minutes before end of ferry loading",
                            VEHICLE_ATTEMPTED_ENTRANCE_AFTER_END_OF_LOADING: "Entrance attempt after the loading end time",
                            VEHICLE_AUTHORIZED_UNSUCCESSFULLY: "Vehicle authorized unsuccessfully during passage attempt",
                            ORDER_ENTERED_PORT: "Status changed to Parking entry",
                            ORDER_ENTERED_DEPO: "Status changed to Depo entry",
                            ORDER_ENTERED_FERRY: "Status changed to Ferry entry",
                            ORDER_EXITED_DEPO: "Status changed to Depo exit",
                            ORDER_EXITED_PORT: "Status changed to Parking exit",
                            ORDER_EXITED_FERRY: "Status changed to Ferry exit",
                            ORDER_CANCELED: "Status changed to Canceled",
                            ORDER_CONFIRMED_BY_MANIFEST: "Status changed to Manifest",
                            NEAR_TIME_TO_FERRY_DEPARTURE: "Ferry for the order departs in {{time}} min"
                        },
                        newAlerts: {
                            header: "New alerts: ",
                            allAlerts: "View all alerts",
                            date: "Date"
                        }
                    },
                    place: {
                        title: "Place management",
                        lightBoards: {
                            title: "Light boards",
                            retrievalErrorSuffix: "light boards retrieval",
                            manualOperatingSign: "Sign",
                            headers: {
                                location: "Location",
                                operatingMode: "Operating mode",
                                currentMessage: "Current message of manual mode"
                            },
                            actions: {
                                changeToManualMode: "Send message to light board",
                                changeToAutoMode: "Turn on auto mode",
                            },
                            operatingModes: {
                                MANUAL: "Manual",
                                AUTO: "Automatic"
                            },
                            manualOperatingPopup: {
                                header: "Manual mode message",
                                manualOperatingMessage: "Message",
                                manualOperatingSign: "Sign code",
                                required: "At least one of the fields must be completed",
                            },
                            signCodes: {
                                LEFT_TURN: "Mandatory left turn",
                                RIGHT_TURN: "Mandatory right turn",
                                AHEAD: "Mandatory ahead",
                                NO_ENTRY: "No entry"
                            },
                            changeMessageErrorSuffix: "change of the board operation mode",
                            sendMessageErrorSuffix: "sending the message"
                        },
                        ownedVehicles: {
                            title: "Owned Vehicles",
                            retrievalErrorSuffix: "owned vehicles retrieval",
                            headers: {
                                regNo: "Reg No",
                                usedBy: "User name",
                                orderNo: "Order No",
                                lastLocation: "Last location"
                            },
                            orderDetailAction: "Preview order details"
                        },
                        ferryOrdersParkings: {
                            title: "Parkings for ferry orders",
                            retrievalErrorSuffix: "retrieval parkings for ferry orders ",
                            headers: {
                                relationType: "Order type",
                                totalNumberOfOrders: "Number of orders",
                                numberOfOrdersInDepo: "Entered Depo",
                                numberOfOrdersExitedDepo: "Exited Depo",
                                ferryName: "Ferry name",
                                arrivalDepartureTime: "Arrival/Departure time"
                            }
                        },
                        nonFerryOrdersParkings: {
                            title: "Parkings for non ferry orders",
                            retrievalErrorSuffix: "retrieval parkings for non ferry orders ",
                            headers: {
                                relationType: "Order type",
                                totalNumberOfOrders: "Number of orders",
                                numberOfOrderInDepo: "Entered Depo",
                                numberOfOrdersExitedDepo: "Exited Depo",
                            }
                        },
                        entryOrExit: {
                            title: "Entry/Exit",
                            headers: {
                                name: "Location",
                                description: "Description of the location",
                                actions: "Entry/exit permit"
                            },
                            actions: {
                                notAllow: "Don't allow",
                                allow: "Allow"
                            },
                            openAllPopup: {
                                header: "Open all",
                                content: "Are you sure you want to open all devices connected to the kiosk ",
                                errorSuffix: "when opening all devices connected to the kiosk",
                            },
                            closeAllPopup: {
                                header: "Close all",
                                content: "Are you sure you want to close all devices connected to the kiosk ",
                                errorSuffix: "when closing all devices connected to the kiosk"
                            },
                            errors: {
                                retrievalErrorSuffix: "list of locations retrieval"
                            }
                        }
                    },
                    reports: {
                        title: "Reports",
                        filterButton: "Generate report",
                        downloadButton: "Download report",
                        downloadSummaryReportButton: "Download summary",
                        generatedReport: "Generated report",
                        generatedSummaryReport: "Summary",
                        seaFerriesSummary: {
                            title: "Summary of sea ferries",
                            filters: {
                                year: "Year",
                                month: "Month"
                            },
                            headers: {
                                shipownerName: "Shipowner name",
                                ferryName: "Ferry",
                                loadingType: "Loading type",
                                billOfLading: "Bill of lading",
                                monthOut: "Month OUT",
                                monthIn: "Month IN",
                                calculatedMonth: "Calculated month",
                                yearOut: "Year OUT",
                                yearIn: "Year IN",
                                calculatedYear: "Calculated year"
                            }
                        },
                        transportRegister: {
                            title: "Transport register",
                            filters: {
                                arrivalFerryFrom: "Arrival of the ferry: From",
                                arrivalFerryTo: "Arrival of the ferry: To",
                                departureFerryFrom: "Departure of the ferry: From",
                                departureFerryTo: "Departure of the ferry: To",
                                shipowner: "Shipowner",
                                ferry: "Ferry",
                                wharf: "Wharf no",
                                originDestinationPort: "Origin/destination port",
                                actionType: "Relation"
                            },
                            headers: {
                                ferryName: "Ferry",
                                shipownerName: "Shipowner name",
                                directionType: "Relation",
                                voyageNo: "Arrival/departure voyage number",
                                arrivalDepartureTime: "Scheduled time of arrival/departure of the ferry",
                                wharf: "Wharf No",
                                originDestinationPort: "Origin destination port",
                                numberOfLorryTrailers: "Tractor with a trailer",
                                numberOfTrailers: "Trailer",
                                numberOfCars: "Cars",
                                numberOfBuses: "Buses",
                                numberOfRailways: "Railways",
                                numberOfGeneralCargos: "General cargos",
                                numberOfContainers: "Containers",
                                vgmSum: "Weight of VGM containers",
                                numberOfOthers: "Others"
                            }
                        },
                        ferryHandlingTime: {
                            title: "Ferry handling time",
                            filters: {
                                arrivalFerryFrom: "Arrival of the ferry: From",
                                arrivalFerryTo: "Arrival of the ferry: To",
                                departureFerryFrom: "Departure of the ferry: From",
                                departureFerryTo: "Departure of the ferry: To",
                                ferry: "Ferry",
                                actionType: "Action type",
                                voyageNo: "Voyage no",
                            },
                            headers: {
                                ferryName: "Ferry name",
                                actionType: "Action type",
                                voyageNo: "Voyage number",
                                firstEntryToTerminal: "First entry to the terminal",
                                lastEntryToTerminal: "Last entry to the terminal",
                                entryTimeDifference: "Difference",
                                scheduledArrivalTimeOfFerry: "Scheduled time of arrival of the ferry",
                                actualArrivalTimeOfFerry: "Actual time of arrival of the ferry",
                                differenceArrivalTime: "Difference",
                                scheduledDepartureTimeOfFerry: "Scheduled time of wharf release",
                                actualDepartureTimeOfFerry: "Actual time of wharf release",
                                differenceDepartureTime: "Difference",
                                notes: "Notes"
                            }
                        },
                        vehicleOrCargoHandlingTime: {
                            title: "Vehicle/Cargo handling time",
                            filters: {
                                bookingNo: "Booking no",
                                lorryRegNo: "Lorry no",
                                trailerRegNo: "Trailer no",
                                containerNo: "Container no",
                                wagonRegNo: "Railway no",
                                dateFrom: "Time from:",
                                dateTo: "Time to:"
                            },
                            headers: {
                                bookingNo: "Booking no",
                                lorryRegNo: "Lorry no",
                                trailerRegNo: "Trailer no",
                                containerNo: "Container no",
                                wagonRegNo: "Railway no",
                                location: "Location name",
                                orderStatus: "Ticket/Order status",
                                createdAt: "Created at",
                                ferryName: "Ferry name",
                                timeBetweenEvents: "Time between events",
                                timeBetweenEventsCumulatively: "Time between events cumulatively"
                            },
                            locationType: {
                                PORT: "Port",
                                DEPO: "Depo",
                                FERRY: "Ferry",
                                PHOTOSHOOTER: "Photoshooter"
                            }
                        },
                        invoiceAttachment: {
                            title: "Invoice attachment",
                            filters: {
                                dateFrom: "Date from:",
                                dateTo: "Date to:",
                                ferry: "Ferry"
                            },
                            headers: {
                                ferryName: "Ferry",
                                directionType: "Relation",
                                voyageNo: "Arrival/departure voyage number",
                                arrivalDepartureTime: "Scheduled time of arrival/departure of the ferry",
                                numberOfPassengers: "Passengers",
                                numberOfDrivers: "Drivers",
                                numberOfLorries: "Lorry trailers",
                                numberOfTrailers: "Trailers",
                                numberOfCars: "Cars",
                                numberOfBuses: "Buses",
                                numberOfWagons: "Railway",
                                numberOfContainers: "Containers",
                                numberOfGeneralCargos: "General cargos",
                                numberOfOthers: "Others",
                                numberOfBillOfLading: "Bill of lading"
                            }
                        },
                        dangerousGoodsRegister: {
                            title: "Register of dangerous goods",
                            filters: {
                                arrivalFerryFrom: "Arrival of the ferry: From",
                                arrivalFerryTo: "Arrival of the ferry: To",
                                departureFerryFrom: "Departure of the ferry: From",
                                departureFerryTo: "Departure of the ferry: To",
                                shipowner: "Shipowner",
                                ferry: "Ferry",
                                voyageNo: "Voyage no",
                                unCode: "UN Code",
                                packing: "Packing"
                            },
                            headers: {
                                ferryName: "Ferry",
                                shipownerName: "Shipowner name",
                                directionType: "Relation",
                                voyageNo: "Arrival/departure voyage number",
                                arrivalDepartureTime: "Scheduled time of arrival/departure of the ferry",
                                actualArrivalDepartureTime: "Actual time of arrival/departure of the ferry",
                                cargoType: "Cargo type",
                                lorryRegNo: "Lorry no",
                                regNo: "Cargo identifier",
                                unCodeValue: "UN code ID",
                                unCodeName: "UN code name",
                                imdgClass: "IMDG class",
                                packingName: "Packing",
                                packingQuantity: "Number of packages",
                                packingGroup: "Packing category",
                                weight: "Weight"
                            }
                        },
                        trailerBase: {
                            title: "Trailer base",
                            filters: {
                                depoEntryDateFrom: "Depo entry date: From",
                                depoEntryDateTo: "Depo entry date: To",
                                depoExitDateFrom: "Depo exit date: From",
                                depoExitDateTo: "Depo exit date: To",
                                bookingDateFrom: "Booking date: From",
                                bookingDateTo: "Booking date: To",
                                cargoType: "Cargo Type",
                                shipper: "Shipper",
                                paymentWaiver: "Payment waiver",
                                ferry: "Ferry",
                                relationType: "Relation",
                                voyageNo: "Voyage no"
                            },
                            headers: {
                                relationType: "Relation type",
                                cargoType: "Cargo type",
                                orderStatus: "Ticket/Order status",
                                ferryName: "Ferry",
                                shipownerName: "Shipowner",
                                depoEntryDate: "Depo enry date",
                                depoExitDate: "Depo exit date",
                                bookingDate: "Booking date",
                                trailerRegNo: "Trailer reg no",
                                lorryRegNo: "Lorry reg no",
                                shipperName: "Company",
                                storageTime: "Storage Time",
                                billableStorageTime: "Storage time subject to charge",
                                paymentMethod: "Payment method",
                                paymentWaiver: "Payment waiver",
                                weight: "Cargo weight",
                                securingDeclaration: "Securing declaration",
                                parkingCost: "Parking cost"
                            }
                        },
                        listOfShipments: {
                            title: "List of shipments",
                            filters: {
                                arrivalFerryFrom: "Arrival of the ferry: From",
                                arrivalFerryTo: "Arrival of the ferry: To",
                                departureFerryFrom: "Departure of the ferry: From",
                                departureFerryTo: "Departure of the ferry: To",
                                shipowner: "Shipowner",
                                ferry: "Ferry",
                                relationType: "Ticket/Order type",
                                cargoType: "Cargo type",
                                orderStatus: "Ticket/Order status",
                                onlySummary: "Only summary"
                            },
                            headers: {
                                relationType: "Ticket/Order type",
                                cargoType: "Cargo type",
                                orderStatus: "Ticket/Order status",
                                bookingNo: "Booking no",
                                ferryName: "Ferry",
                                shipownerName: "Shipowner",
                                directionType: "Relation",
                                voyageNo: "Arrival/departure voyage number",
                                arrivalDepartureTime: "Scheduled time of arrival/departure of the ferry",
                                actualArrivalDepartureTime: "Actual time of arrival/departure of the ferry",
                                originDestinationPort: "Origin destination port",
                                lorryRegNo: "Lorry no",
                                trailerRegNo: "Trailer no",
                                containerNo: "Container no",
                                wagonRegNo: "Railway no",
                                weight: "Weight of the load",
                                numberOfOrders: "Number of tickets/orders",
                            },
                            errors: {
                                oneDateRequired: "One of the dates must be given"
                            }
                        },
                        actions: {
                            download: {
                                header: "Choose a file format",
                                actionText: "Download"
                            }
                        },
                        errors: {
                            downloadErrorSuffix: "downloading the report",
                            correctDateWithTime: "Invalid date with time",
                            generateReportErrorSuffix: "generate report",
                            generateSummaryReportErrorSuffix: "generate summary report",
                            downloadSummaryReportErrorSuffix: "downloading the report summary",

                        }
                    },
                    priceList: {
                        title: "Price list",
                        retrievalErrorSuffix: "loading the price list",
                        headers: {
                            priceListType: "Relation",
                            startDate: "Start date",
                            parkingTime: "Parking time (H)",
                            parkingFee: "Rate (PLN/24H)",
                            validFrom: "Valid from"
                        },
                        actions: {
                            addPrice: "Add price +",
                            modifyPrice: "Modify",
                            addNextPriceList: "Dodaj kolejny +",
                        },
                        addPrice: {
                            header: "Add new price list",
                            saveButtonText: "Add",
                        },
                        errors: {
                            getPriceErrorSuffix: "downloading the price list",
                            addErrorSuffix: "adding a new price list",
                            editErrorSuffix: "editing a price list",
                            dateValidFrom: "Date must be in the future",
                            isOneFreeTime: "You cannot enter another free time",
                            hasNoMoreThanTwoDecimalPlacesOrEmptyAndPositiveNumber: "Invalid format or negative number",
                            isMultipleTimes: "The parking time must be a multiple of 24",
                            numberGreaterThanZero: "The number must be greater than 0",
                            freeParkingRateAtIncorrectPosition: "Free time is not the first item"
                        },
                        removePriceList: {
                            header: "Are you sure you want to delete {{value}}?",
                            price: "price list",
                            parkingRate: "parking time with rate",
                            secondHeader: "Remove {{value}}",
                            actionText: "Yes, remove",
                            line1: "Are you sure you want to delete {{value}}?",
                            line2: "This action cannot be reverted!",
                            errorMessagePart1: "removing the price list"
                        }
                    }
                }
            }
        }
    });

export default i18n;
